import * as i0 from '@angular/core';
import { Injectable, Component, Inject, Input, ViewChild, EventEmitter, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import * as i3$2 from 'base-document-checklist-library';
import { BaseDocumentChecklistLibraryService, APIDocumentChecklist } from 'base-document-checklist-library';
import * as i4 from '@angular/forms';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as errorUtils from 'error-message-utility';
import { takeUntil, take } from 'rxjs/operators';
import { acceptedFileTypes } from 'app-models';
import * as i1$1 from 'primeng/api';
import * as i2 from 'ngx-toastr';
import * as i3 from 'send-notification';
import * as i5 from '@angular/common';
import * as i6 from 'primeng/tree';
import * as i7 from 'primeng/confirmdialog';
import * as i8 from 'primeng/dialog';
import * as i9 from 'primeng/checkbox';
import * as i10 from 'primeng/dropdown';
import * as i11 from 'primeng/button';
import * as i12 from 'bulk-documents-download';
import { BulkDocumentsDownloadModule } from 'bulk-documents-download';
import * as i13 from '@angular/material/icon';
import * as i14 from 'primeng/inplace';
import * as i15 from 'primeng/inputtext';
import * as i16 from 'primeng/tooltip';
import * as i17 from 'primeng/radiobutton';
import * as i18 from 'primeng/divider';
import { Subject, forkJoin } from 'rxjs';
import * as i1$2 from '@angular/router';
import * as i4$1 from '@angular/material/badge';
import { MatBadgeModule } from '@angular/material/badge';
import * as i3$1 from '@angular/material/table';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { environment } from 'environment-configurations';
import { PrimengLibraryModule } from 'primeng-library';

class DocumentChecklistNewLibraryService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
}
DocumentChecklistNewLibraryService.ɵfac = function DocumentChecklistNewLibraryService_Factory(t) { return new (t || DocumentChecklistNewLibraryService)(i0.ɵɵinject(i1.HttpClient)); };
DocumentChecklistNewLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: DocumentChecklistNewLibraryService, factory: DocumentChecklistNewLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DocumentChecklistNewLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0$2 = ["documentChecklistForm"];
function DocumentChecklistNewLibraryComponent_div_2_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 52);
    i0.ɵɵelementStart(1, "button", 53);
    i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_div_2_span_5_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.addNewTitleSheet(true); });
    i0.ɵɵelement(2, "span", 54);
    i0.ɵɵelementStart(3, "span", 55);
    i0.ɵɵtext(4, "Add New Title Sheet");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", !ctx_r18.titleSheetButtonEnabled);
} }
function DocumentChecklistNewLibraryComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "div", 44);
    i0.ɵɵelementStart(2, "h6", 45);
    i0.ɵɵtext(3, "Required document checklist for petition");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 46);
    i0.ɵɵtemplate(5, DocumentChecklistNewLibraryComponent_div_2_span_5_Template, 5, 1, "span", 47);
    i0.ɵɵelementStart(6, "button", 48);
    i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_div_2_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.confirmReset(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 49);
    i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_div_2_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r22); const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.setDisplayDocumentPanel(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "lib-bulk-documents-download", 50);
    i0.ɵɵelementStart(9, "mat-icon", 51);
    i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_div_2_Template_mat_icon_click_9_listener() { i0.ɵɵrestoreView(_r22); const ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.editDocumentCheckList(); });
    i0.ɵɵtext(10, "edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.isEdit);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("selectedFiles", ctx_r1.selectedFiles);
} }
function DocumentChecklistNewLibraryComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "div", 56);
    i0.ɵɵelementStart(2, "button", 57);
    i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_div_3_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.expandCollapseAll(); });
    i0.ɵɵelement(3, "span");
    i0.ɵɵelementStart(4, "span", 58);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵclassMapInterpolate1("p-button-icon pr-1 pi pi-chevron-circle-", ctx_r2.allExpanded ? "up" : "down", "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r2.allExpanded ? "Collapse" : "Expand", " All");
} }
function DocumentChecklistNewLibraryComponent_ng_template_6_p_inplace_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵelementStart(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 80);
    i0.ɵɵtext(4, "(Edit Title)");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r27 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(node_r27.data.titleSheetName);
} }
function DocumentChecklistNewLibraryComponent_ng_template_6_p_inplace_2_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 81);
    i0.ɵɵlistener("ngModelChange", function DocumentChecklistNewLibraryComponent_ng_template_6_p_inplace_2_ng_template_3_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r42); const node_r27 = i0.ɵɵnextContext(2).$implicit; return (node_r27.data["tempTitleSheetName"] = $event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(1, "button", 82);
    i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_ng_template_6_p_inplace_2_ng_template_3_Template_button_click_1_listener($event) { i0.ɵɵrestoreView(_r42); i0.ɵɵnextContext(); const _r36 = i0.ɵɵreference(1); const node_r27 = i0.ɵɵnextContext().$implicit; const ctx_r43 = i0.ɵɵnextContext(); return ctx_r43.renameTitleSheet($event, node_r27, _r36); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r27 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate1("name", "tempTitleSheetName", node_r27.nodeIndex, "");
    i0.ɵɵpropertyInterpolate1("id", "titleSheetName", node_r27.nodeIndex, "");
    i0.ɵɵproperty("ngModel", node_r27.data["tempTitleSheetName"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", node_r27.data["tempTitleSheetName"] == "");
} }
const _c1$1 = function () { return { "min-height": "33px" }; };
function DocumentChecklistNewLibraryComponent_ng_template_6_p_inplace_2_Template(rf, ctx) { if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-inplace", 75, 76);
    i0.ɵɵlistener("onActivate", function DocumentChecklistNewLibraryComponent_ng_template_6_p_inplace_2_Template_p_inplace_onActivate_0_listener($event) { i0.ɵɵrestoreView(_r48); const node_r27 = i0.ɵɵnextContext().$implicit; const ctx_r46 = i0.ɵɵnextContext(); return ctx_r46.onActivateInplace($event, node_r27, "titleSheetName" + node_r27.nodeIndex); });
    i0.ɵɵtemplate(2, DocumentChecklistNewLibraryComponent_ng_template_6_p_inplace_2_ng_template_2_Template, 5, 1, "ng-template", 77);
    i0.ɵɵtemplate(3, DocumentChecklistNewLibraryComponent_ng_template_6_p_inplace_2_ng_template_3_Template, 2, 4, "ng-template", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(2, _c1$1));
} }
function DocumentChecklistNewLibraryComponent_ng_template_6_p_inplace_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵelementStart(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 80);
    i0.ɵɵtext(4, "(Edit Title)");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r27 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(node_r27.data.categoryName);
} }
function DocumentChecklistNewLibraryComponent_ng_template_6_p_inplace_3_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 84);
    i0.ɵɵlistener("ngModelChange", function DocumentChecklistNewLibraryComponent_ng_template_6_p_inplace_3_ng_template_3_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r55); const node_r27 = i0.ɵɵnextContext(2).$implicit; return (node_r27.data["tempTitleSheetName"] = $event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(1, "button", 82);
    i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_ng_template_6_p_inplace_3_ng_template_3_Template_button_click_1_listener($event) { i0.ɵɵrestoreView(_r55); i0.ɵɵnextContext(); const _r49 = i0.ɵɵreference(1); const node_r27 = i0.ɵɵnextContext().$implicit; const ctx_r56 = i0.ɵɵnextContext(); return ctx_r56.renameCustomTitleSheet($event, node_r27, _r49); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r27 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate1("name", "tempTitleSheetName", node_r27.nodeIndex, "");
    i0.ɵɵproperty("ngModel", node_r27.data["tempTitleSheetName"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", !node_r27.data["tempTitleSheetName"]);
} }
function DocumentChecklistNewLibraryComponent_ng_template_6_p_inplace_3_Template(rf, ctx) { if (rf & 1) {
    const _r61 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-inplace", 75, 83);
    i0.ɵɵlistener("onActivate", function DocumentChecklistNewLibraryComponent_ng_template_6_p_inplace_3_Template_p_inplace_onActivate_0_listener($event) { i0.ɵɵrestoreView(_r61); const node_r27 = i0.ɵɵnextContext().$implicit; const ctx_r59 = i0.ɵɵnextContext(); return ctx_r59.onActivateInplace($event, node_r27, "titleSheetNameCustom"); });
    i0.ɵɵtemplate(2, DocumentChecklistNewLibraryComponent_ng_template_6_p_inplace_3_ng_template_2_Template, 5, 1, "ng-template", 77);
    i0.ɵɵtemplate(3, DocumentChecklistNewLibraryComponent_ng_template_6_p_inplace_3_ng_template_3_Template, 2, 3, "ng-template", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(2, _c1$1));
} }
function DocumentChecklistNewLibraryComponent_ng_template_6_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r64 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 85);
    i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_ng_template_6_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r64); const node_r27 = i0.ɵɵnextContext().$implicit; const ctx_r62 = i0.ɵɵnextContext(); return ctx_r62.setDisplayAddDocumentPanel(true, node_r27); });
    i0.ɵɵelement(1, "span", 86);
    i0.ɵɵelementStart(2, "span", 55);
    i0.ɵɵtext(3, "Add Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function DocumentChecklistNewLibraryComponent_ng_template_6_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r67 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 87);
    i0.ɵɵelementStart(1, "button", 88);
    i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_ng_template_6_div_6_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r67); const node_r27 = i0.ɵɵnextContext().$implicit; const ctx_r65 = i0.ɵɵnextContext(); return ctx_r65.deleteTitleSheet(node_r27); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r27 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", node_r27.children.length > 0);
} }
function DocumentChecklistNewLibraryComponent_ng_template_6_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 91);
    i0.ɵɵelement(1, "i", 92);
    i0.ɵɵelement(2, "i", 93);
    i0.ɵɵelementEnd();
} }
const _c2$1 = function (a0) { return { cursor: a0 }; };
function DocumentChecklistNewLibraryComponent_ng_template_6_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 89);
    i0.ɵɵtemplate(1, DocumentChecklistNewLibraryComponent_ng_template_6_div_7_div_1_Template, 3, 0, "div", 90);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r27 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(3, _c2$1, node_r27.class == "custom" ? "default" : "pointer"))("tooltipDisabled", node_r27.class == "custom");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r27.class != "custom");
} }
function DocumentChecklistNewLibraryComponent_ng_template_6_p_checkbox_12_Template(rf, ctx) { if (rf & 1) {
    const _r72 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-checkbox", 94);
    i0.ɵɵlistener("onChange", function DocumentChecklistNewLibraryComponent_ng_template_6_p_checkbox_12_Template_p_checkbox_onChange_0_listener($event) { i0.ɵɵrestoreView(_r72); const node_r27 = i0.ɵɵnextContext().$implicit; const ctx_r71 = i0.ɵɵnextContext(); return ctx_r71.selectAllDocs($event, ctx_r71.bulkDownloadCheckboxes[node_r27.nodeIndex]); })("ngModelChange", function DocumentChecklistNewLibraryComponent_ng_template_6_p_checkbox_12_Template_p_checkbox_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r72); const node_r27 = i0.ɵɵnextContext().$implicit; const ctx_r74 = i0.ɵɵnextContext(); return ctx_r74.bulkDownloadCheckboxes[node_r27.nodeIndex].isAllSelected = $event; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r27 = i0.ɵɵnextContext().$implicit;
    const ctx_r33 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("name", "selectedAll", node_r27.nodeIndex, "");
    i0.ɵɵpropertyInterpolate1("value", "allDocTypes", node_r27.nodeIndex, "");
    i0.ɵɵpropertyInterpolate1("inputId", "documentType", node_r27.nodeIndex, "");
    i0.ɵɵproperty("ngModel", ctx_r33.bulkDownloadCheckboxes[node_r27.nodeIndex].isAllSelected);
} }
function DocumentChecklistNewLibraryComponent_ng_template_6_p_checkbox_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-checkbox", 95);
} if (rf & 2) {
    i0.ɵɵproperty("disabled", true);
} }
function DocumentChecklistNewLibraryComponent_ng_template_6_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 96);
    i0.ɵɵelementStart(1, "tr");
    i0.ɵɵelementStart(2, "td");
    i0.ɵɵelementStart(3, "small", 97);
    i0.ɵɵtext(4, "Drag & Drop related documents to this title sheet.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function DocumentChecklistNewLibraryComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵelementStart(1, "div", 60);
    i0.ɵɵtemplate(2, DocumentChecklistNewLibraryComponent_ng_template_6_p_inplace_2_Template, 4, 3, "p-inplace", 61);
    i0.ɵɵtemplate(3, DocumentChecklistNewLibraryComponent_ng_template_6_p_inplace_3_Template, 4, 3, "p-inplace", 61);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 62);
    i0.ɵɵtemplate(5, DocumentChecklistNewLibraryComponent_ng_template_6_button_5_Template, 4, 0, "button", 63);
    i0.ɵɵtemplate(6, DocumentChecklistNewLibraryComponent_ng_template_6_div_6_Template, 2, 1, "div", 64);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, DocumentChecklistNewLibraryComponent_ng_template_6_div_7_Template, 2, 5, "div", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 66);
    i0.ɵɵelementStart(9, "div", 67);
    i0.ɵɵelementStart(10, "tr", 68);
    i0.ɵɵelementStart(11, "th", 69);
    i0.ɵɵtemplate(12, DocumentChecklistNewLibraryComponent_ng_template_6_p_checkbox_12_Template, 1, 4, "p-checkbox", 70);
    i0.ɵɵtemplate(13, DocumentChecklistNewLibraryComponent_ng_template_6_p_checkbox_13_Template, 1, 1, "p-checkbox", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "th", 72);
    i0.ɵɵtext(15, " Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "th", 72);
    i0.ɵɵtext(17, "Document Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "th");
    i0.ɵɵelementStart(19, "span", 73);
    i0.ɵɵtext(20, "Action");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(21, DocumentChecklistNewLibraryComponent_ng_template_6_div_21_Template, 5, 0, "div", 74);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r27 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", node_r27.class != "custom");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r27.class == "custom");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", node_r27.class != "custom" && node_r27["data"]["masterTitleSheetId"] && ctx_r3.isEdit);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r27.class == "custom");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.disabledControls && ctx_r3.isEdit);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", node_r27.class !== "custom");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r27.class === "custom");
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngIf", node_r27.class == "custom" && node_r27.children.length == 0);
} }
function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 111);
} }
function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const singleDoc_r81 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(singleDoc_r81.fileName);
} }
function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 112);
    i0.ɵɵelement(1, "i", 113);
    i0.ɵɵtext(2, " Document Missing ");
    i0.ɵɵelementEnd();
} }
function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r94 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 114);
    i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_button_12_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r94); const singleDoc_r81 = i0.ɵɵnextContext().$implicit; const ctx_r92 = i0.ɵɵnextContext(3); return ctx_r92.viewDocument(singleDoc_r81.fileLocation); });
    i0.ɵɵelementStart(1, "mat-icon", 115);
    i0.ɵɵtext(2, "visibility");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c3 = function (a0) { return { "invisible": a0 }; };
function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r97 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 116);
    i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_button_13_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r97); const singleDoc_r81 = i0.ɵɵnextContext().$implicit; const ctx_r95 = i0.ɵɵnextContext(3); return ctx_r95.confirmDelete(singleDoc_r81.documentId ? singleDoc_r81.documentId : singleDoc_r81.id); });
    i0.ɵɵelementStart(1, "mat-icon", 117);
    i0.ɵɵtext(2, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const childNode_r77 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c3, childNode_r77.data.class == "customChild"));
} }
function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_button_14_Template(rf, ctx) { if (rf & 1) {
    const _r101 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 118);
    i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_button_14_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r101); const childNode_r77 = i0.ɵɵnextContext(3).$implicit; const ctx_r99 = i0.ɵɵnextContext(); return ctx_r99.notifyDocument(childNode_r77); });
    i0.ɵɵelementStart(1, "mat-icon", 119);
    i0.ɵɵtext(2, "notifications");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_button_15_Template(rf, ctx) { if (rf & 1) {
    const _r104 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 120);
    i0.ɵɵelementStart(1, "mat-icon", 121);
    i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_button_15_Template_mat_icon_click_1_listener() { i0.ɵɵrestoreView(_r104); const _r102 = i0.ɵɵreference(4); return _r102.click(); });
    i0.ɵɵtext(2, "publish");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 122, 123);
    i0.ɵɵlistener("change", function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_button_15_Template_input_change_3_listener($event) { i0.ɵɵrestoreView(_r104); const childNode_r77 = i0.ɵɵnextContext(3).$implicit; const ctx_r105 = i0.ɵɵnextContext(); return ctx_r105.uploadDoc($event.target.files, childNode_r77); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r89 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("accept", ctx_r89.acceptedTypes);
} }
function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 124);
    i0.ɵɵelement(1, "i", 92);
    i0.ɵɵelement(2, "i", 125);
    i0.ɵɵelementEnd();
} }
function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r108 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 96);
    i0.ɵɵtemplate(1, DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_div_1_Template, 1, 0, "div", 100);
    i0.ɵɵelementStart(2, "tr", 101);
    i0.ɵɵelementStart(3, "td", 69);
    i0.ɵɵelementStart(4, "p-checkbox", 102);
    i0.ɵɵlistener("onChange", function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_Template_p_checkbox_onChange_4_listener($event) { i0.ɵɵrestoreView(_r108); const childNode_r77 = i0.ɵɵnextContext(2).$implicit; const ctx_r107 = i0.ɵɵnextContext(); return ctx_r107.selectDoc($event, ctx_r107.bulkDownloadCheckboxes[childNode_r77.parentIndex]); })("ngModelChange", function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_Template_p_checkbox_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r108); const i_r82 = ctx.index; const childNode_r77 = i0.ɵɵnextContext(2).$implicit; const ctx_r110 = i0.ɵɵnextContext(); return (ctx_r110.bulkDownloadCheckboxes[childNode_r77.parentIndex]["childItems"][childNode_r77.nodeIndex]["documents"][i_r82]["isSelected"] = $event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 103);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 103);
    i0.ɵɵtemplate(8, DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_span_8_Template, 2, 1, "span", 20);
    i0.ɵɵtemplate(9, DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_span_9_Template, 3, 0, "span", 104);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td");
    i0.ɵɵelementStart(11, "span", 105);
    i0.ɵɵtemplate(12, DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_button_12_Template, 3, 0, "button", 106);
    i0.ɵɵtemplate(13, DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_button_13_Template, 3, 3, "button", 107);
    i0.ɵɵtemplate(14, DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_button_14_Template, 3, 0, "button", 108);
    i0.ɵɵtemplate(15, DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_button_15_Template, 5, 1, "button", 109);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_div_16_Template, 3, 0, "div", 110);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r82 = ctx.index;
    const childNode_r77 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r80 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r82 > 0);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate2("inputId", "documentType", childNode_r77.data.titleSheetDetailId, "", i_r82, "");
    i0.ɵɵpropertyInterpolate2("name", "selectedDoc", childNode_r77.data.titleSheetDetailId, "", i_r82, "");
    i0.ɵɵproperty("ngModel", ctx_r80.bulkDownloadCheckboxes[childNode_r77.parentIndex]["childItems"][childNode_r77.nodeIndex]["documents"][i_r82]["isSelected"]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", childNode_r77.data.docName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", childNode_r77.data.present);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !childNode_r77.data.present);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", childNode_r77.data.present);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", childNode_r77.data.present);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !childNode_r77.data.present);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !childNode_r77.data.present);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r80.disabledControls && ctx_r80.isEdit);
} }
function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_div_1_Template, 17, 14, "div", 99);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const childNode_r77 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", childNode_r77.data.documents);
} }
function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_2_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 124);
    i0.ɵɵelement(1, "i", 92);
    i0.ɵɵelement(2, "i", 125);
    i0.ɵɵelementEnd();
} }
function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r117 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 96);
    i0.ɵɵelementStart(2, "tr", 101);
    i0.ɵɵelementStart(3, "td", 69);
    i0.ɵɵelement(4, "p-checkbox", 95);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 103);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 103);
    i0.ɵɵelementStart(8, "span", 112);
    i0.ɵɵelement(9, "i", 113);
    i0.ɵɵtext(10, " Document Missing ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td");
    i0.ɵɵelementStart(12, "span", 105);
    i0.ɵɵelementStart(13, "button", 118);
    i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_2_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r117); const childNode_r77 = i0.ɵɵnextContext().$implicit; const ctx_r115 = i0.ɵɵnextContext(); return ctx_r115.notifyDocument(childNode_r77); });
    i0.ɵɵelementStart(14, "mat-icon", 119);
    i0.ɵɵtext(15, "notifications");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_2_div_16_Template, 3, 0, "div", 110);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const childNode_r77 = i0.ɵɵnextContext().$implicit;
    const ctx_r79 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", childNode_r77.data.docName, " ");
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngIf", !ctx_r79.disabledControls && ctx_r79.isEdit);
} }
function DocumentChecklistNewLibraryComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 98);
    i0.ɵɵtemplate(1, DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_1_Template, 2, 1, "ng-container", 20);
    i0.ɵɵtemplate(2, DocumentChecklistNewLibraryComponent_ng_template_7_ng_container_2_Template, 17, 3, "ng-container", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const childNode_r77 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", childNode_r77.data.documents.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !childNode_r77.data.documents.length);
} }
function DocumentChecklistNewLibraryComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r120 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 126);
    i0.ɵɵelementStart(1, "div", 127);
    i0.ɵɵelementStart(2, "button", 53);
    i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_div_9_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r120); const ctx_r119 = i0.ɵɵnextContext(); return ctx_r119.addNewTitleSheet(false); });
    i0.ɵɵelement(3, "span", 54);
    i0.ɵɵelementStart(4, "span", 55);
    i0.ɵɵtext(5, "Add New Title Sheet");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r5.titleSheetButtonEnabled);
} }
function DocumentChecklistNewLibraryComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r122 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "div", 128);
    i0.ɵɵelementStart(2, "button", 129);
    i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_div_10_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r122); const ctx_r121 = i0.ɵɵnextContext(); return ctx_r121.onClickCancel(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 130);
    i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_div_10_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r122); const ctx_r123 = i0.ɵɵnextContext(); return ctx_r123.onClickSaveDocs(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function DocumentChecklistNewLibraryComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵelementStart(2, "div", 14);
    i0.ɵɵelementStart(3, "h5", 131);
    i0.ɵɵtext(4, "Request for Missing Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function DocumentChecklistNewLibraryComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r127 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p-radioButton", 132);
    i0.ɵɵlistener("ngModelChange", function DocumentChecklistNewLibraryComponent_div_20_Template_p_radioButton_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r127); const ctx_r126 = i0.ɵɵnextContext(); return ctx_r126.requestDocNotifyTo = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const requestTo_r124 = ctx.$implicit;
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("pl-0 ", ctx_r8.requestDocNotifyToArray.length > 1 ? "ml-2" : "", "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", requestTo_r124.value)("label", requestTo_r124.label)("ngModel", ctx_r8.requestDocNotifyTo);
} }
function DocumentChecklistNewLibraryComponent_p_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 133);
    i0.ɵɵtext(1, "Select required documents below each title sheet");
    i0.ɵɵelementEnd();
} }
function DocumentChecklistNewLibraryComponent_div_23_div_1_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r137 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 142);
    i0.ɵɵelementStart(1, "p-checkbox", 143);
    i0.ɵɵlistener("onChange", function DocumentChecklistNewLibraryComponent_div_23_div_1_ng_container_6_div_1_Template_p_checkbox_onChange_1_listener($event) { i0.ɵɵrestoreView(_r137); const ctx_r136 = i0.ɵɵnextContext(4); return ctx_r136.documentSelected($event); })("ngModelChange", function DocumentChecklistNewLibraryComponent_div_23_div_1_ng_container_6_div_1_Template_p_checkbox_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r137); const documentType_r133 = i0.ɵɵnextContext().$implicit; return documentType_r133.selectedDocumentType = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 144);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const documentType_r133 = i0.ɵɵnextContext().$implicit;
    const ctx_r135 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r135.individualNotification)("value", documentType_r133)("inputId", documentType_r133.titleSheetDetailId)("ngModel", documentType_r133.selectedDocumentType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", documentType_r133.titleSheetDetailId);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(documentType_r133.docName);
} }
function DocumentChecklistNewLibraryComponent_div_23_div_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DocumentChecklistNewLibraryComponent_div_23_div_1_ng_container_6_div_1_Template, 4, 6, "div", 141);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const documentType_r133 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !documentType_r133.present && (documentType_r133 == null ? null : documentType_r133.showIndividual));
} }
function DocumentChecklistNewLibraryComponent_div_23_div_1_p_divider_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider", 145);
} }
function DocumentChecklistNewLibraryComponent_div_23_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 135);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵelementStart(2, "label", 136);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 137);
    i0.ɵɵelementStart(5, "div", 138);
    i0.ɵɵtemplate(6, DocumentChecklistNewLibraryComponent_div_23_div_1_ng_container_6_Template, 2, 1, "ng-container", 139);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, DocumentChecklistNewLibraryComponent_div_23_div_1_p_divider_7_Template, 1, 0, "p-divider", 140);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r129 = ctx.$implicit;
    const i_r130 = ctx.index;
    const ctx_r128 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r129.titleSheetName);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", item_r129.documentTypes);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r130 < ctx_r128.supportingDocumentsForNotification.length - 1);
} }
function DocumentChecklistNewLibraryComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtemplate(1, DocumentChecklistNewLibraryComponent_div_23_div_1_Template, 8, 3, "div", 134);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r10.supportingDocumentsForNotification);
} }
function DocumentChecklistNewLibraryComponent_p_divider_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider");
} }
function DocumentChecklistNewLibraryComponent_div_40_Template(rf, ctx) { if (rf & 1) {
    const _r142 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 146);
    i0.ɵɵelementStart(1, "label", 27);
    i0.ɵɵtext(2, "Document Type Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 147);
    i0.ɵɵlistener("ngModelChange", function DocumentChecklistNewLibraryComponent_div_40_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r142); const ctx_r141 = i0.ɵɵnextContext(); return ctx_r141.customDocTypeForNotification = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r12.customDocTypeForNotification);
} }
function DocumentChecklistNewLibraryComponent_div_46_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r146 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h6", 150);
    i0.ɵɵtext(2, "Add Notes / Comments for Beneficiary");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 151);
    i0.ɵɵlistener("ngModelChange", function DocumentChecklistNewLibraryComponent_div_46_div_1_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r146); const ctx_r145 = i0.ɵɵnextContext(2); return ctx_r145.beneficiaryNotes = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r143 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("col-", ctx_r143.requestDocNotifyTo == "both" ? "6 border-right" : "10", " pl-0 pb-2");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r143.beneficiaryNotes);
} }
function DocumentChecklistNewLibraryComponent_div_46_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r148 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h6", 150);
    i0.ɵɵtext(2, "Add Notes / Comments for Petitioner");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 151);
    i0.ɵɵlistener("ngModelChange", function DocumentChecklistNewLibraryComponent_div_46_div_2_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r148); const ctx_r147 = i0.ɵɵnextContext(2); return ctx_r147.petitionerNotes = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r144 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("col-", ctx_r144.requestDocNotifyTo == "both" ? "6" : "10 pl-0 pb-2", "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r144.petitionerNotes);
} }
function DocumentChecklistNewLibraryComponent_div_46_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 148);
    i0.ɵɵtemplate(1, DocumentChecklistNewLibraryComponent_div_46_div_1_Template, 4, 4, "div", 149);
    i0.ɵɵtemplate(2, DocumentChecklistNewLibraryComponent_div_46_div_2_Template, 4, 4, "div", 149);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.requestDocNotifyTo == "both" || ctx_r13.requestDocNotifyTo == "beneficiary");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.userType == "Attorney" && (ctx_r13.requestDocNotifyTo == "both" || ctx_r13.requestDocNotifyTo == "petitioner"));
} }
function DocumentChecklistNewLibraryComponent_div_47_Template(rf, ctx) { if (rf & 1) {
    const _r150 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 148);
    i0.ɵɵelementStart(1, "div", 152);
    i0.ɵɵelementStart(2, "h6", 150);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 151);
    i0.ɵɵlistener("ngModelChange", function DocumentChecklistNewLibraryComponent_div_47_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r150); const ctx_r149 = i0.ɵɵnextContext(); return ctx_r149.beneficiaryNotes = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("Add Notes / Comments for ", ctx_r14.requestDocNotifyToArray[0]["label"], "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r14.beneficiaryNotes);
} }
function DocumentChecklistNewLibraryComponent_ng_template_52_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵelementStart(2, "div", 14);
    i0.ɵɵelementStart(3, "h5", 131);
    i0.ɵɵtext(4, "Add Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function DocumentChecklistNewLibraryComponent_div_67_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 154);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r151 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r151.getGlobalErrorMessages("REQUIRED"), " ");
} }
function DocumentChecklistNewLibraryComponent_div_67_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, DocumentChecklistNewLibraryComponent_div_67_span_1_Template, 2, 1, "span", 153);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.addDocTypeForm.controls["docType"].errors == null ? null : ctx_r16.addDocTypeForm.controls["docType"].errors.required);
} }
function DocumentChecklistNewLibraryComponent_div_68_div_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 154);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r153 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r153.getGlobalErrorMessages("REQUIRED"), " ");
} }
function DocumentChecklistNewLibraryComponent_div_68_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, DocumentChecklistNewLibraryComponent_div_68_div_4_span_1_Template, 2, 1, "span", 153);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r152 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r152.addDocTypeForm.controls["docName"].errors == null ? null : ctx_r152.addDocTypeForm.controls["docName"].errors.required);
} }
function DocumentChecklistNewLibraryComponent_div_68_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 155);
    i0.ɵɵelementStart(1, "label");
    i0.ɵɵtext(2, "Document Type Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 156);
    i0.ɵɵtemplate(4, DocumentChecklistNewLibraryComponent_div_68_div_4_Template, 2, 1, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r17.addDocTypeForm.controls["docName"].touched && ctx_r17.addDocTypeForm.controls["docName"].invalid);
} }
const _c4 = function () { return { width: "1000px", minWidth: "200px" }; };
const _c5 = function () { return { width: "500px", minWidth: "200px" }; };
class DocumentChecklistNewLibraryComponent extends BaseDocumentChecklistLibraryService {
    constructor(confirmationService, toastr, apiService, notificationService) {
        super(toastr, apiService);
        this.confirmationService = confirmationService;
        this.toastr = toastr;
        this.apiService = apiService;
        this.notificationService = notificationService;
        this.selectedCategoryType = [];
        this.requestDocNotifyTo = 'both';
        this.categories = [];
        this.documentType = [];
        this.individualNotification = false;
        this.displayDocumentPanel = false;
        this.displayAddDocumentPanel = false;
        this.notificationStatusUpdate = "";
        this.additionalDocuments = false;
        this.maxfileSizeInMB = 10;
        this.addDocTypeFileSizeError = false;
        this.addDocTypeForm = new FormGroup({
            docType: new FormControl('', [Validators.required]),
            docFile: new FormControl(''),
            docFileSource: new FormControl('')
        });
        this.listDocumentTypes = [];
        this.docTreeExpandedArr = [];
        this.allExpanded = false;
        this.isFamilyBased = false;
        this.requestDocNotifyToArray = [
            { label: 'Petitioner(Client)', value: 'petitioner' },
            { label: 'Beneficiary', value: 'beneficiary' },
            { label: 'Both', value: 'both' }
        ];
        this.bulkDownloadCheckboxes = [];
        this.selectedFiles = [];
        this.acceptedTypes = acceptedFileTypes;
        this.documentsList = [];
        this.isEdit = false;
        this.disabledControls = false;
    }
    ngOnInit() {
        this.inputData = this.primaryData;
        this.visaType = this.inputData.visatype;
        this.userType = sessionStorage.getItem("userTypeRole");
        this.buildToNotification();
        this.refreshDocuments();
    }
    ngAfterViewInit() {
        this.documentChecklistForm = this.documentChecklistForm;
        this.mapAndBuildDocsForNotification();
    }
    refreshDocuments() {
        //Store previous expanded state
        this.titleSheetButtonEnabled = true;
        this.docTreeExpandedArr = [];
        if (this.requiredDocumentsTree) {
            let prevousDocumentsTree = this.requiredDocumentsTree.filter((el) => el.children.length);
            prevousDocumentsTree.forEach((element, index) => {
                this.docTreeExpandedArr.push({ nodeIndex: index, expanded: element.expanded });
            });
            this.docTreeExpandedState = this.docTreeExpandedArr;
        }
        const promise = this.getRequiredDocument();
        promise.then(() => {
            this.documentChecklistForm = this.documentChecklistForm;
            this.mapAndBuildDocsForNotification();
            this.updateSupportingDocuments();
            this.buildDownloadCheckboxes();
        }, (error) => {
            this.requiredDocumentsTree = [];
            console.log(error);
        });
    }
    buildDownloadCheckboxes() {
        // debugger;
        this.bulkDownloadCheckboxes = [];
        this.requiredDocumentsTree.forEach((node, index) => {
            // if(node.data.titleSheetId === 3132){
            //   debugger;
            // }
            let tempNode = { id: node.data.titleSheetId, isAllSelected: false, childItems: [] };
            node === null || node === void 0 ? void 0 : node.children.forEach((child) => {
                let cTempNode = { id: child.data.titleSheetDetailId, parentIndex: index, documents: Array.from(child.data.documents, function (el) { el['isSelected'] = false; return el; }) };
                tempNode.childItems.push(cTempNode);
            });
            this.bulkDownloadCheckboxes.push(tempNode);
        });
        console.log("this.bulkDownloadCheckboxes", this.bulkDownloadCheckboxes);
    }
    selectAllDocs(event, node) {
        node.childItems.forEach((item) => {
            item['documents'].forEach((doc) => { doc.isSelected = node.isAllSelected; });
        });
        //update selected files
        this.buildSelectedFiles();
    }
    selectDoc(event, node) {
        let checkedItems = 0;
        let totalItems = 0;
        node.childItems.forEach((item) => {
            checkedItems += item.documents.filter((doc) => doc.isSelected).length;
            totalItems += item.documents.length;
        });
        node.isAllSelected = (checkedItems == totalItems);
        //update selected files
        this.buildSelectedFiles();
    }
    buildSelectedFiles() {
        this.selectedFiles = [];
        const allChildItems = this.bulkDownloadCheckboxes.reduce((acc, item) => [...acc, ...item.childItems], []);
        const allDocuments = allChildItems.reduce((acc, item) => [...acc, ...item.documents], []);
        allDocuments.forEach(doc => {
            if (doc.isSelected)
                this.selectedFiles.push({ fileLocation: doc.fileLocation, fileName: doc.fileName });
        });
    }
    buildToNotification() {
        if (['K3', 'K1', 'ASYLUM'].includes(this.primaryData.visatype) || this.primaryData.caseType == 'I130') {
            this.requestDocNotifyToArray = this.requestDocNotifyToArray.filter((x) => x.value == 'beneficiary');
            if (this.primaryData.visatype != 'ASYLUM') {
                this.requestDocNotifyToArray[0]['label'] = 'Sponsor';
            }
            else {
                this.requestDocNotifyToArray[0]['label'] = 'Beneficiary';
            }
        }
        else {
            if (this.userType == 'Petitioner') {
                this.requestDocNotifyToArray = this.requestDocNotifyToArray.filter((x) => x.value == 'beneficiary');
            }
            else {
                this.requestDocNotifyToArray = this.requestDocNotifyToArray.filter((x) => ['beneficiary', 'petitioner', 'both'].includes(x.value));
            }
        }
        this.requestDocNotifyTo = this.requestDocNotifyToArray[0]['value'];
    }
    mapAndBuildDocsForNotification() {
        var _a;
        this.categories = [];
        this.supportingDocuments = (_a = this.supportingDocuments) === null || _a === void 0 ? void 0 : _a.map((element) => {
            element["showLabelForCheckbox"] = false;
            element.documentTypes = element.documentTypes.map((docType) => {
                if (!docType.present && docType.docName != 'Other') {
                    element["showLabelForCheckbox"] = false;
                    docType["selectedDocumentType"] = false;
                    docType["notifyTo"] = this.requestDocNotifyTo;
                    docType["showIndividual"] = true;
                }
                return docType;
            });
            let { titleSheetName, titleSheetId, documentTypes } = element;
            this.categories.push({ titleSheetName, titleSheetId, documentTypes });
            this.selectedCategoryType.push(element);
            return element;
        });
        this.selectedCategoryForNotification = this.categories.length ? this.categories[0]['titleSheetId'] : null;
    }
    onActivateInplace(event, node, inputId) {
        node.data['tempTitleSheetName'] = node.data.titleSheetName;
        setTimeout(() => {
            let inputEl = document.getElementById(inputId);
            inputEl.setAttribute('tabindex', '0');
            inputEl.focus();
        });
    }
    documentSelected(event) {
        //console.log('event:',event);
    }
    expandCollapseAll() {
        this.allExpanded = !this.allExpanded;
        this.requiredDocumentsTree.forEach(node => {
            this.expandRecursive(node, this.allExpanded);
        });
    }
    /*Add Document Type Popup code */
    setDisplayAddDocumentPanel(flag, node) {
        this.displayAddDocumentPanel = flag;
        this.currentTitleSheet = node;
        this.addDocTypeForm.reset();
        this.updateDocType(node);
    }
    onDocTypeSelect(event) {
        if ((event === null || event === void 0 ? void 0 : event.value) === 'Other') {
            this.addDocTypeForm.addControl('docName', new FormControl('', [Validators.required]));
        }
        else {
            this.addDocTypeForm.removeControl('docName');
        }
    }
    addDocumentType() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        let payload = { documents: [] };
        let node;
        let selectedDocType = this.addDocTypeForm.get('docType').value;
        node = this.currentTitleSheet.data.documentTypes.filter((x) => x.docName === selectedDocType);
        //let entityId = node[0]?.entityId;
        // debugger
        let entityId = this.getEntityId(node[0]);
        if (selectedDocType === 'Other') {
            payload = Object.assign(Object.assign({}, payload), { otherName: this.addDocTypeForm.get('docName').value, fileCategoryId: (_a = node[0]) === null || _a === void 0 ? void 0 : _a.fileCategory, titleSheetName: (_b = this.currentTitleSheet.data) === null || _b === void 0 ? void 0 : _b.titleSheetName, titleSheetId: (_c = this.currentTitleSheet.data) === null || _c === void 0 ? void 0 : _c.titleSheetId });
            // payload.append('otherName', this.addDocTypeForm.get('docName').value);
            // payload.append('fileCategoryId',node[0]?.fileCategory);
            // payload.append('titleSheetName',this.currentTitleSheet.data?.titleSheetName);
            // payload.append('titleSheetId',this.currentTitleSheet.data?.titleSheetId);
            //In case of US company and Foriegn Company need to send the entityId
            const entityValueNode = this.currentTitleSheet.data.documentTypes.filter((x) => x.entityId);
            if (entityValueNode.length) {
                entityId = (_d = entityValueNode[0]) === null || _d === void 0 ? void 0 : _d.entityId;
            }
        }
        else {
            payload = Object.assign(Object.assign({}, payload), { docName: (_e = node[0]) === null || _e === void 0 ? void 0 : _e.docName });
            //payload.append('docName', node[0]?.docName);
        }
        if (node[0]['familyId']) {
            payload = Object.assign(Object.assign({}, payload), { familyId: node[0]['familyId'] });
            //payload.append('familyId', node[0]['familyId']);
        }
        // console.log('this.requiredDocumentsTree', this.requiredDocumentsTree);
        // console.log('currentTitleSheet', this.currentTitleSheet?.data);
        // console.log('nodenode', node);
        // console.log('this.currentTitleSheet?', this.currentTitleSheet);
        let childObj = {
            parentIndex: (_f = this.currentTitleSheet) === null || _f === void 0 ? void 0 : _f.nodeIndex,
            nodeIndex: (_g = this.currentTitleSheet) === null || _g === void 0 ? void 0 : _g.children.length,
            data: {
                "otherName": this.addDocTypeForm.get('docName').value,
                "docName": this.addDocTypeForm.get('docName').value,
                "titleSheetDetailId": (_j = (_h = this.currentTitleSheet) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.documentTypes[((_l = (_k = this.currentTitleSheet) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.documentTypes.length) - 1].titleSheetDetailId,
                "titleSheetDetailSequenceNo": ((_o = (_m = this.currentTitleSheet) === null || _m === void 0 ? void 0 : _m.data) === null || _o === void 0 ? void 0 : _o.documentTypes[((_q = (_p = this.currentTitleSheet) === null || _p === void 0 ? void 0 : _p.data) === null || _q === void 0 ? void 0 : _q.documentTypes.length) - 1].titleSheetDetailSequenceNo) + 1,
                "isGenerated": null,
                "documents": [],
                "fileCategory": (_r = this.listDocumentTypes.find((dt) => dt.code === 'OTHER')) === null || _r === void 0 ? void 0 : _r.id,
                "fileCategoryCode": "OTHER",
                "fileGroupCategoryCode": (_s = this.listDocumentTypes.find((dt) => dt.code === 'OTHER')) === null || _s === void 0 ? void 0 : _s.group,
                "entityId": null,
                "familyId": null,
                "tempDoc": false,
                "present": false,
            },
            type: 'child'
        };
        console.log('childObj', childObj);
        this.currentTitleSheet.children = [...(_t = this.currentTitleSheet) === null || _t === void 0 ? void 0 : _t.children, childObj];
        this.toastr.success('Document type added successfully');
        this.addDocTypeForm.reset();
        this.displayAddDocumentPanel = false;
    }
    onDocFileSelected(event) {
        if (event.target.files.length > 0) {
            if (event.target.files[0].size / 1024 / 1024 > this.maxfileSizeInMB) {
                this.addDocTypeFileSizeError = true;
                return;
            }
            this.addDocTypeFileSizeError = false;
            const file = event.target.files[0];
            file.fileName = event.target.files[0].name;
            this.addDocTypeForm.patchValue({
                docFileSource: file
            });
        }
    }
    deleteDocType(node) {
        //console.log('node:', node);
    }
    /*Add Document Type Popup code */
    notifyDocument(docType) {
        this.displayDocumentPanel = true;
        this.individualNotification = true;
        let selectedCategoryTypeTemp = [];
        this.buildToNotification();
        this.beneficiaryNotes = '';
        this.petitionerNotes = '';
        this.supportingDocuments.forEach((element) => {
            if (element.titleSheetName == docType.parent.data.titleSheetName) {
                element["showLabelForCheckbox"] = true;
                element.documentTypes.forEach(doc => {
                    if (docType.data.docName == doc.docName) {
                        doc["selectedDocumentType"] = true;
                        doc["notifyTo"] = this.requestDocNotifyTo;
                        doc["showIndividual"] = true;
                    }
                    else {
                        doc["selectedDocumentType"] = false;
                        doc["showIndividual"] = false;
                    }
                });
                selectedCategoryTypeTemp.push(element);
            }
        });
        this.supportingDocumentsForNotification = selectedCategoryTypeTemp;
    }
    /*Request Document Popup code */
    updateSupportingDocuments() {
        this.supportingDocuments = this.supportingDocuments.map((element) => {
            element.documentTypes = element.documentTypes.filter((docType) => !docType.present);
            return element;
        });
        let previousSupportingDocList = this.supportingDocumentsForNotification;
        this.supportingDocumentsForNotification = this.supportingDocuments.filter((element) => {
            return element.documentTypes.filter((docType) => docType.docName != 'Other').length;
        });
        if (previousSupportingDocList) {
            this.supportingDocumentsForNotification.forEach((el, elI) => {
                el['documentTypes'] = el.documentTypes.map((dt) => {
                    let previousDocType = previousSupportingDocList[elI] ? previousSupportingDocList[elI]['documentTypes'].filter((x) => x.docName == dt.docName) : [];
                    if (previousDocType.length) {
                        dt['selectedDocumentType'] = previousDocType[0]['selectedDocumentType'];
                    }
                    else {
                        dt['selectedDocumentType'] = false;
                    }
                    return dt;
                });
            });
        }
    }
    setDisplayDocumentPanel() {
        var _a;
        this.individualNotification = false;
        this.displayDocumentPanel = true;
        this.beneficiaryNotes = '';
        this.petitionerNotes = '';
        this.mapAndBuildDocsForNotification();
        this.updateSupportingDocuments();
        this.updateDocType((_a = this.categories[0]) === null || _a === void 0 ? void 0 : _a.titleSheetId, true);
    }
    categorySelected(event, item) {
        item.documentTypes.forEach(doc => {
            doc["selectedDocumentType"] = event.checked;
        });
    }
    updateDocType(selectedCategory, fromNotification = false) {
        var _a;
        this.listDocumentTypes = [];
        let docTypes;
        if (!fromNotification) {
            docTypes = (_a = selectedCategory.data) === null || _a === void 0 ? void 0 : _a.documentTypes.filter((dt) => !dt.present);
        }
        else {
            let catagory = this.categories.filter((cat) => cat.titleSheetId == selectedCategory);
            docTypes = catagory[0]['documentTypes'].filter((dt) => !dt.present);
        }
        //In case of if multiple OTHER coming for Beneficiary Documents title sheet.
        const beneFcryDocmtsIndex = docTypes.findIndex((x) => x.fileGroupCategoryCode === "BENOTHDOC");
        if (beneFcryDocmtsIndex > -1) {
            docTypes = docTypes.filter((dt) => (!dt.present && dt.fileCategoryCode !== 'OTHER') || (!dt.present && dt.fileCategoryCode === 'OTHER' && dt.fileGroupCategoryCode === 'BENOTHDOC'));
        }
        //In case of if multiple OTHER coming for Sponsor Documents title sheet.
        const sponsorDocmtsIndex = docTypes.findIndex((x) => x.fileGroupCategoryCode === "SPONSOROTHDOC");
        if (sponsorDocmtsIndex > -1) {
            docTypes = docTypes.filter((dt) => (!dt.present && dt.fileCategoryCode !== 'OTHER') || (!dt.present && dt.fileCategoryCode === 'OTHER' && dt.fileGroupCategoryCode === 'SPONSOROTHDOC'));
        }
        const onlyOther = docTypes.filter((dt) => dt.fileCategoryCode === 'OTHER');
        this.listDocumentTypes = onlyOther.map(x => {
            return {
                code: x.fileCategoryCode,
                name: x.docName,
                id: x.fileCategory,
                desc: x.docName,
                group: x.fileGroupCategoryCode
            };
        });
        console.log('this.listDocumentTypes', this.listDocumentTypes);
        //this.listDocumentTypes = 
        if (fromNotification) {
            this.setDocTypeOther();
        }
    }
    setCustomEmpty() {
        this.customDocTypeForNotification = undefined;
    }
    setDocTypeOther() {
        if (this.listDocumentTypes.length > 0) {
            const otherDoctype = this.listDocumentTypes.filter((x) => x.code == 'OTHER' && x.name == 'Other');
            this.selectedDocTypeForNotification = otherDoctype.length ? otherDoctype[0].name : this.listDocumentTypes[0].name;
        }
        else {
            this.selectedDocTypeForNotification = undefined;
        }
        this.setCustomEmpty();
    }
    addNewCategory() {
        if (this.selectedDocTypeForNotification == 'Other' && (this.customDocTypeForNotification == undefined || this.customDocTypeForNotification == '')) {
            this.toastr.error("Please enter a document type name");
        }
        else if (this.selectedDocTypeForNotification != 'Other' && this.selectedDocTypeForNotification != undefined) {
            this.toastr.error("Document type already exists");
        }
        else {
            let payload = {
                docName: this.customDocTypeForNotification,
                titleSheetDetailId: '',
                titleSheetName: '',
                fileCategory: '',
                titleSheetId: ''
            };
            let titleSheet = this.supportingDocuments.filter((x) => x.titleSheetId === this.selectedCategoryForNotification);
            //console.log('titleSheet:',titleSheet);
            let selectedDocType = titleSheet[0]['documentTypes'].filter((docType) => docType.docName == this.selectedDocTypeForNotification);
            //console.log('selectedDocType:',selectedDocType);
            if (selectedDocType.length) {
                payload.fileCategory = selectedDocType[0]['fileCategory'];
                payload.titleSheetDetailId = selectedDocType[0]['titleSheetDetailId'];
                payload.titleSheetName = titleSheet[0]['titleSheetName'];
                payload.titleSheetId = titleSheet[0]['titleSheetId'];
                if (selectedDocType[0]['familyId']) {
                    payload['familyId'] = selectedDocType[0]['familyId'];
                }
                this.apiService.addDocumentType(this.primaryData.caseType, this.primaryData.caseId, titleSheet[0]['titleSheetId'], payload).subscribe((response) => {
                    var _a;
                    if (response.status == 200) {
                        this.refreshDocuments();
                        this.updateDocType((_a = this.categories[0]) === null || _a === void 0 ? void 0 : _a.titleSheetId, true);
                        this.toastr.success(response.message);
                    }
                });
            }
        }
    }
    sendNotification() {
        var _a, _b, _c;
        let documents = JSON.parse(JSON.stringify(this.supportingDocuments));
        //console.log('Documents:',documents);
        if (this.individualNotification)
            documents = this.supportingDocumentsForNotification;
        let titleSheetDocDtoList = [];
        documents.forEach((element) => {
            element.documentTypes = element.documentTypes.filter((x) => x.docName != 'Other');
            //console.log('Document Types after Other:',element.documentTypes);
            element.documentTypes.forEach(doc => {
                if (doc.selectedDocumentType && !doc.present) {
                    titleSheetDocDtoList.push({
                        "categoryDtlId": element.titleSheetId,
                        "categoryName": element.titleSheetName,
                        "notifyTo": this.requestDocNotifyTo,
                        "titleSheetDetailDocName": doc.docName,
                        "titleSheetDetailId": doc.titleSheetDetailId
                    });
                }
            });
        });
        if (!titleSheetDocDtoList.length) {
            this.toastr.error('Please select atleast One required document.');
        }
        else {
            let payload = {
                "petitionerNotes": this.petitionerNotes,
                "beneficiaryNotes": this.beneficiaryNotes,
                "beneficiaryId": ['both', 'beneficiary'].includes(this.requestDocNotifyTo) ? this.primaryData.beneficiaryId : null,
                "companyId": (_a = this.primaryData) === null || _a === void 0 ? void 0 : _a.companyId,
                "taskId": (_b = this.primaryData) === null || _b === void 0 ? void 0 : _b.subTaskId,
                "superTaskId": (_c = this.primaryData) === null || _c === void 0 ? void 0 : _c.superTaskId,
                "employeeId": ['both', 'petitioner'].includes(this.requestDocNotifyTo) ? (this.primaryData['employeeId'] ? this.primaryData['employeeId'] : this.primaryData['immSpecialistId']) : null,
                "channelType": "",
                "notificationType": "PET_DOC_MISS",
                "notifyAllBeneficiaries": false,
                "notifyAllEmployees": false,
                "priority": "",
                "titleSheetDocDtoList": titleSheetDocDtoList
            };
            if (['K3', 'K1'].includes(this.primaryData.visatype) || this.primaryData.caseType == 'I130') {
                payload['beneficiaryId'] = this.primaryData['sponsorId'];
            }
            this.apiService.sendNotification(this.primaryData.caseId, payload).subscribe((response) => {
                if (response.status == 200) {
                    this.toastr.success(response.message);
                    this.displayDocumentPanel = false;
                }
            });
        }
    }
    /*Request Document Popup code */
    /* Add/Delete Title Sheet */
    addNewTitleSheet(fromTop) {
        let tempData = this.requiredDocumentsTree;
        var element = {}, data = {};
        let children = [];
        data["categoryName"] = "Add Title";
        data["categoryId"] = null;
        data["categorySequenceNo"] = fromTop ? 0 : this.newTitleSheetSequenceNo;
        data["titleSheetSequnceNo"] = fromTop ? 0 : this.newTitleSheetSequenceNo;
        data["class"] = "custom";
        element["data"] = data;
        element["class"] = "custom";
        element["type"] = "parent";
        element["children"] = children;
        element["expanded"] = true;
        element["nodeIndex"] = tempData.length;
        if (fromTop) {
            tempData.unshift(element);
        }
        else {
            tempData.push(element);
        }
        this.requiredDocumentsTree = tempData;
        this.titleSheetButtonEnabled = false;
        this.buildDownloadCheckboxes();
    }
    deleteTitleSheet(node) {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete?',
            key: 'docchecklist',
            accept: () => {
                let removeIndex = this.requiredDocumentsTree.map(function (item) { return item.data.categoryId; }).indexOf(null);
                this.requiredDocumentsTree.splice(removeIndex, 1);
                this.titleSheetButtonEnabled = true;
                this.buildDownloadCheckboxes();
                this.toastr.success("Title sheet deleted successfully");
            },
            reject: () => {
            }
        });
    }
    /* Add/Delete Title Sheet */
    uploadDoc(files, node) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const file = files.item(0);
        if (file.size / 1024 / 1024 > this.maxfileSizeInMB) {
            this.toastr.error(`File size should be less than or equal to ${this.maxfileSizeInMB}MB`);
            return;
        }
        file.fileName = files.item(0).name;
        const payload = new FormData();
        payload.append('file', file, file.name);
        if (((_a = node.data) === null || _a === void 0 ? void 0 : _a.fileCategoryCode) == 'OTHER') {
            payload.append('otherName', (_b = node.data) === null || _b === void 0 ? void 0 : _b.docName);
            payload.append('fileCategoryId', (_c = node.data) === null || _c === void 0 ? void 0 : _c.fileCategory);
            payload.append('titleSheetName', (_e = (_d = node.parent) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.titleSheetName);
            payload.append('titleSheetDetailId', (_f = node.data) === null || _f === void 0 ? void 0 : _f.titleSheetDetailId);
            payload.append('titleSheetId', (_h = (_g = node.parent) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.titleSheetId);
        }
        if (node['data']['familyId']) {
            payload.append('familyId', node['data']['familyId']);
        }
        let entityId = this.getEntityId(node.data);
        this.apiService.saveUploadedDocument(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId, (_j = node.data) === null || _j === void 0 ? void 0 : _j.fileGroupCategoryCode, (_k = node.data) === null || _k === void 0 ? void 0 : _k.fileCategoryCode, entityId, this.primaryData.superTaskId, this.primaryData.subTaskId, payload).subscribe((response) => {
            this.refreshDocuments();
            this.toastr.success(response.message);
        });
    }
    deleteDocument(item) {
        this.apiService.deleteDocument(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId, item, this.primaryData.superTaskId, this.primaryData.subTaskId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.refreshDocuments();
            this.toastr.success(response.message);
        });
    }
    confirmDelete(item) {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete?',
            key: 'docchecklist',
            accept: () => {
                this.deleteDocument(item);
            },
            reject: () => {
            }
        });
    }
    renameTitleSheet(event, node, editor) {
        this.apiService.renameTitleSheet(this.primaryData.caseType, this.primaryData.subTaskId, node.data.titleSheetId, node.data.tempTitleSheetName)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response.status == 200) {
                node.data.titleSheetName = node.data.tempTitleSheetName;
                this.toastr.success(response.message);
            }
            else {
                this.toastr.error(response.message);
            }
        });
        editor.deactivate(event);
    }
    renameCustomTitleSheet(event, node, editor) {
        var _a;
        if (!((_a = node.data) === null || _a === void 0 ? void 0 : _a.categoryId)) {
            //Tempararly assigning the new Name to the existing one bcz Title sheet will get saved on drop of child node.
            node.data['categoryName'] = node.data.titleSheetName = node.data.tempTitleSheetName;
            this.toastr.success("Title Sheet Renamed");
            editor.deactivate(event);
        }
        else {
            this.renameTitleSheet(event, node, editor);
        }
    }
    onDrop(event) {
        //Prevent new title sheet to be dragged if doesn't have documents
        if (event.dragNode['class'] && event.dragNode['class'] == 'custom') {
            event.reject();
        }
        if (event.dragNode.type == "parent" && event.dropNode.type == "child") {
            event.reject();
        }
        if (event.dropNode.class == 'custom') {
            event.dragNode.data["class"] = "customChild";
        }
        else {
            event.dragNode.data["class"] = "";
        }
        if (event.originalEvent.currentTarget.className === 'p-treenode-droppoint ng-star-inserted p-treenode-droppoint-active') {
            if (event.dragNode.type == "child" && event.dropNode.type == "parent")
                event.reject();
            else
                event.accept();
            this.saveDocumentsData();
        }
        else {
            if (event.originalEvent.currentTarget.className === "p-treenode-content p-treenode-dragover") {
                if (event.dragNode.type == event.dropNode.type) {
                }
                else
                    event.accept();
                this.saveDocumentsData();
            }
            else
                event.accept();
        }
    }
    nodeExpandCollapse(event, flag) {
        if (flag === 'expand') {
            const expandedTree = this.requiredDocumentsTree.filter((item) => item.expanded);
            if (expandedTree.length === this.requiredDocumentsTree.length) {
                this.allExpanded = true;
            }
        }
        else {
            const collapsedTree = this.requiredDocumentsTree.filter((item) => !item.expanded);
            if (collapsedTree.length === this.requiredDocumentsTree.length) {
                this.allExpanded = false;
            }
        }
    }
    saveDocumentsData() {
        // let documentsList = []; 
        this.documentsList = [];
        this.docTreeExpandedArr = [];
        this.requiredDocumentsTree.forEach((element, index) => {
            let obj = {};
            let tempChild = [];
            if (element.data.class != "custom")
                obj["titleSheetName"] = element["data"]["titleSheetName"];
            else
                obj["titleSheetName"] = element["data"]["categoryName"];
            obj["categorySequenceNo"] = index;
            obj["titleSheetSequnceNo"] = index;
            obj["titleSheetId"] = element["data"]["titleSheetId"];
            if (element["children"] != undefined) {
                element["children"].forEach((doc, ind) => {
                    let child = doc['data'];
                    child["titleSheetDetailSequenceNo"] = index + ind;
                    tempChild.push(child);
                });
                obj["documentTypes"] = tempChild;
            }
            // documentsList.push(obj);
            this.documentsList.push(obj);
        });
        // this.apiService.postRequiredDocument(this.primaryData.visatype, this.primaryData.caseType,
        //   this.primaryData.caseId,this.primaryData.superTaskId, documentsList).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
        //   if (response) {
        //     this.refreshDocuments();
        //     this.toastr.success(response.message);
        //   }
        // });
    }
    onClickSaveDocs() {
        this.saveDocumentsData();
        console.log('this.documentsList', this.documentsList);
        this.apiService.postRequiredDocument(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId, this.primaryData.superTaskId, this.documentsList).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.isEdit = false;
                this.refreshDocuments();
                this.toastr.success(response.message);
            }
        });
    }
    onClickCancel() {
        this.isEdit = false;
        this.ngOnInit();
    }
    editDocumentCheckList() {
        this.isEdit = true;
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    confirmReset() {
        this.confirmationService.confirm({
            message: 'Are you sure you want to reset the Document list?',
            key: 'docchecklistreset',
            accept: () => {
                this.resetRequiredDocument();
            },
            reject: () => {
            }
        });
    }
    resetRequiredDocument() {
        this.apiService.resetRequiredDocuments(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId, this.primaryData.subTaskId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.refreshDocuments();
                this.toastr.success(response.message);
            }
        });
    }
    getEntityId(item) {
        if (item && item['entityId']) {
            return item['entityId'];
        }
        if (['COMPGENDOC', 'COMPOTHDOC'].includes(item['fileGroupCategoryCode'])) {
            return this.primaryData.companyId;
        }
        return null;
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
DocumentChecklistNewLibraryComponent.ɵfac = function DocumentChecklistNewLibraryComponent_Factory(t) { return new (t || DocumentChecklistNewLibraryComponent)(i0.ɵɵdirectiveInject(i1$1.ConfirmationService), i0.ɵɵdirectiveInject(i2.ToastrService), i0.ɵɵdirectiveInject(APIDocumentChecklist), i0.ɵɵdirectiveInject(i3.SendNotificationService)); };
DocumentChecklistNewLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: DocumentChecklistNewLibraryComponent, selectors: [["lib-document-checklist-new-library"]], viewQuery: function DocumentChecklistNewLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.documentChecklistForm = _t.first);
    } }, inputs: { primaryData: "primaryData", disabledControls: "disabledControls" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 72, vars: 48, consts: [[3, "ngClass"], ["documentChecklistForm", "ngForm"], ["class", "row", 4, "ngIf"], [1, "pr-3", "pl-3"], ["draggableScope", "self", "droppableScope", "self", "emptyMessage", "No Data Available", 3, "value", "draggableNodes", "droppableNodes", "validateDrop", "onNodeDrop", "onNodeExpand", "onNodeCollapse"], ["pTemplate", "parent"], ["pTemplate", "child"], ["header", "Delete", "key", "docchecklist"], ["class", "row", "id", "addNewTitleSheet", 4, "ngIf"], ["header", "Confirm Reset", "key", "docchecklistreset"], [3, "styleClass", "visible", "modal", "responsive", "minY", "maximizable", "visibleChange"], ["pTemplate", "header"], [1, "mt-0"], [1, "row"], [1, "col-12", "px-0"], [1, "mb-0"], [1, "row", "pt-2", "request-for"], [3, "class", 4, "ngFor", "ngForOf"], ["class", "pt-2", 4, "ngIf"], ["class", "row form-group", 4, "ngIf"], [4, "ngIf"], [3, "hidden"], [1, "mt-2"], ["name", "group2", "binary", "true", "inputId", "additional", 3, "ngModel", "ngModelChange"], ["for", "additional", 1, "d-inline-block", "mb-0", "ml-2", "font-weight-bold"], [1, "row", "pl-2", "mt-2"], [1, "col-3"], [1, "small"], ["panelStyleClass", "dc-dropdown-panel", "appendTo", "body", "optionLabel", "titleSheetName", "optionValue", "titleSheetId", 1, "w-100", 3, "options", "ngModel", "ngModelChange", "onChange"], ["panelStyleClass", "dc-dropdown-panel", "appendTo", "body", "optionLabel", "name", "optionValue", "name", 1, "w-100", 3, "options", "ngModel", "ngModelChange", "onChange"], ["class", "col-4 pl-2", 4, "ngIf"], [1, "col-2", "pl-2"], [1, "small", "mb-1", "d-block", "invisible"], ["type", "button", "pButton", "", "label", "ADD", 1, "p-button-outlined", "mt-1", 3, "click"], ["class", "row mt-2", 4, "ngIf"], ["type", "button", "pButton", "", "label", "Cancel", 1, "p-button-secondary", "mr-3", "cancel-btn", "p-button-raised", 3, "click"], ["type", "button", "pButton", "", "label", "Request Now", 3, "disabled", "click"], [1, "row", "form-group"], [3, "formGroup"], [1, "col-7", "mb-3", "mt-2", "px-0"], ["panelStyleClass", "dc-dropdown-panel", "appendTo", "body", "formControlName", "docType", "required", "", "placeholder", "Select Type", "optionValue", "name", "optionLabel", "name", 3, "options", "onChange"], ["class", "col-7  mt-2 mb-3 px-0", 4, "ngIf"], ["type", "button", "pButton", "", "label", "Cancel", 1, "p-button-secondary", "cancel-btn", "p-button-raised", 3, "click"], ["type", "button", "pButton", "", "label", "Add Now", 3, "disabled", "click"], [1, "col-md-5", "d-flex", "align-items-center"], [1, "heading"], [1, "col-md-7", "pl-0", "action-block"], ["class", "add-title-sheet", 4, "ngIf"], ["pButton", "", "type", "button", "label", "Reset to Default", 1, "p-button-outlined", "ml-1", 3, "click"], ["pButton", "", "type", "button", "label", "Request for Documents", 1, "p-button-outlined", "ml-1", 3, "click"], ["fileName", "Petition-Documents.zip", 3, "selectedFiles"], ["matTooltip", "Edit", 1, "ml-1", "editCustom", 3, "click"], [1, "add-title-sheet"], ["type", "button", 1, "linkButton", "p-button", "p-component", 3, "disabled", "click"], ["aria-hidden", "true", 1, "p-button-icon", "p-button-icon-left", "fa", "fa-plus"], [1, "p-button-label"], [1, "col-md-12", "d-flex"], ["type", "button", 1, "p-0", "p-button", "p-component", "p-button-link", 3, "click"], ["aria-hidden", "true", 1, "p-button-label"], [1, "row", "mt-3", "mb-2"], [1, "col-7", "pl-0"], ["closable", "closable", "class", "titleSheet", 3, "style", "onActivate", 4, "ngIf"], [1, "col-4", "text-right", "add-doc-btn", "px-0"], ["type", "button", "class", "p-button p-component p-0 p-button-icon bg-white text-primary border-0", 3, "click", 4, "ngIf"], ["class", "pl-0", 4, "ngIf"], ["class", "col-1", "pTooltip", "Drag & Drop", 3, "ngStyle", "tooltipDisabled", 4, "ngIf"], [1, "p-datatable", "p-datatable-header", "border", "mb-3", "mt-3", "ml-n4", 2, "width", "100.9%"], [1, "p-datatable-thead"], [2, "min-width", "100%", "display", "inline-table"], [2, "width", "5%"], ["binary", "true", 3, "name", "value", "inputId", "ngModel", "onChange", "ngModelChange", 4, "ngIf"], [3, "disabled", 4, "ngIf"], [1, "dc-table-head", 2, "width", "40%"], [1, "dc-table-head"], ["class", "p-datatable-tbody", 4, "ngIf"], ["closable", "closable", 1, "titleSheet", 3, "onActivate"], ["inplace", ""], ["pTemplate", "display"], ["pTemplate", "content"], [1, "d-inline"], [1, "text-primary", "ml-2"], ["type", "text", "pInputText", "", "required", "", 3, "ngModel", "name", "id", "ngModelChange"], ["pButton", "", "type", "button", "label", "Save", 1, "ml-2", "button-success", 3, "disabled", "click"], ["inplaceCustom", ""], ["type", "text", "id", "titleSheetNameCustom", "pInputText", "", "required", "", 3, "ngModel", "name", "ngModelChange"], ["type", "button", 1, "p-button", "p-component", "p-0", "p-button-icon", "bg-white", "text-primary", "border-0", 3, "click"], [1, "pi", "pi-plus", "p-button-icon", "p-button-icon-left"], [1, "pl-0"], ["pButton", "", "pTooltip", "Delete", "type", "button", "label", "Delete Title sheet", 1, "linkButton", 3, "disabled", "click"], ["pTooltip", "Drag & Drop", 1, "col-1", 3, "ngStyle", "tooltipDisabled"], ["class", "text-right", 4, "ngIf"], [1, "text-right"], ["aria-hidden", "true", 1, "fa", "fa-ellipsis-v", "text-secondary"], ["aria-hidden", "true", 1, "fa", "fa-ellipsis-v", "text-secondary", "ml-0", "mr-4"], ["binary", "true", 3, "name", "value", "inputId", "ngModel", "onChange", "ngModelChange"], [3, "disabled"], [1, "p-datatable-tbody"], [1, "text-secondary"], [1, "p-datatable"], ["class", "p-datatable-tbody", 4, "ngFor", "ngForOf"], ["class", "border", 4, "ngIf"], [1, "d-flex", "align-items-center"], ["binary", "true", 3, "inputId", "name", "ngModel", "onChange", "ngModelChange"], [2, "width", "40%"], ["class", "redColor d-flex align-items-center", 4, "ngIf"], [1, "align-top"], ["pButton", "", "type", "button", "pTooltip", "View", "class", "p-0 p-button-icon-only bg-white border-0 text-secondary d-inline", 3, "click", 4, "ngIf"], ["pButton", "", "type", "button", "class", "p-0 p-button-icon-only bg-white border-0 text-secondary d-inline delete-button", 3, "ngClass", "click", 4, "ngIf"], ["pButton", "", "type", "button", "pTooltip", "Notify", "class", "p-0 p-button-icon-only bg-white border-0 text-secondary d-inline", 3, "click", 4, "ngIf"], ["pButton", "", "type", "button", "pTooltip", "Upload", "class", "p-0 p-button-icon-only bg-white border-0 text-secondary d-inline", 4, "ngIf"], ["class", "d-inline pl-1 drag-drop-icon", "pTooltip", "Drag & Drop", 4, "ngIf"], [1, "border"], [1, "redColor", "d-flex", "align-items-center"], [1, "pi", "pi-exclamation-triangle", "pr-2"], ["pButton", "", "type", "button", "pTooltip", "View", 1, "p-0", "p-button-icon-only", "bg-white", "border-0", "text-secondary", "d-inline", 3, "click"], ["matTooltip", "View", 1, "mr-1", "icn"], ["pButton", "", "type", "button", 1, "p-0", "p-button-icon-only", "bg-white", "border-0", "text-secondary", "d-inline", "delete-button", 3, "ngClass", "click"], ["matTooltip", "Delete", "pTooltip", "Delete", 1, "material-icons"], ["pButton", "", "type", "button", "pTooltip", "Notify", 1, "p-0", "p-button-icon-only", "bg-white", "border-0", "text-secondary", "d-inline", 3, "click"], ["matTooltip", "Notify", 1, "mr-1", "icn"], ["pButton", "", "type", "button", "pTooltip", "Upload", 1, "p-0", "p-button-icon-only", "bg-white", "border-0", "text-secondary", "d-inline"], ["matTooltip", "Upload", 1, "mr-1", "icn", 3, "click"], ["type", "file", "max-size", "5000000", 2, "display", "none", 3, "accept", "change"], ["uploadFile", ""], ["pTooltip", "Drag & Drop", 1, "d-inline", "pl-1", "drag-drop-icon"], ["aria-hidden", "true", 1, "fa", "fa-ellipsis-v", "text-secondary", "ml-0", "mr-2"], ["id", "addNewTitleSheet", 1, "row"], [1, "col-md-12", "pb-3", "add-title-sheet"], [1, "col-md-12", "mb-3"], ["type", "button", "pButton", "", "label", "Cancel", 1, "ml-2", "p-button-secondary", "cancel-btn", "p-button-raised", "pull-right", 3, "click"], ["pButton", "", "type", "button", "label", "Save", 1, "ml-2", "button-success", "pull-right", 3, "click"], [1, "text-primary", "mb-0"], ["name", "notifyTo", 1, "mr-2", 3, "value", "label", "ngModel", "ngModelChange"], [1, "pt-2"], ["class", "row pl-0 outerRow w-100", 4, "ngFor", "ngForOf"], [1, "row", "pl-0", "outerRow", "w-100"], [1, "d-inline-block", "mb-0", "font-weight-bold"], [1, "col-12", "innerRow", "px-0"], [1, "row", "pt-3", "pb-3"], [4, "ngFor", "ngForOf"], ["class", "w-100", "type", "dashed", 4, "ngIf"], ["class", "col-4 d-flex pb-2 pl-0 checkbox-outer", 4, "ngIf"], [1, "col-4", "d-flex", "pb-2", "pl-0", "checkbox-outer"], ["name", "group3", "value", "documentType", "binary", "true", 3, "disabled", "value", "inputId", "ngModel", "onChange", "ngModelChange"], [1, "d-inline-block", "mb-0", "ml-2", 3, "for"], ["type", "dashed", 1, "w-100"], [1, "col-4", "pl-2"], ["type", "text", "pInputText", "", 3, "ngModel", "ngModelChange"], [1, "row", "mt-2"], [3, "class", 4, "ngIf"], [1, "mt-1"], ["type", "text", "pInputText", "", 2, "width", "100%", "height", "80px", 3, "ngModel", "ngModelChange"], [1, "col-10", "pl-0", "pb-2"], ["class", "invalid-message", 4, "ngIf"], [1, "invalid-message"], [1, "col-7", "mt-2", "mb-3", "px-0"], ["type", "text", "pInputText", "", "formControlName", "docName", "required", ""]], template: function DocumentChecklistNewLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0, 1);
        i0.ɵɵtemplate(2, DocumentChecklistNewLibraryComponent_div_2_Template, 11, 2, "div", 2);
        i0.ɵɵtemplate(3, DocumentChecklistNewLibraryComponent_div_3_Template, 6, 4, "div", 2);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "p-tree", 4);
        i0.ɵɵlistener("onNodeDrop", function DocumentChecklistNewLibraryComponent_Template_p_tree_onNodeDrop_5_listener($event) { return ctx.onDrop($event); })("onNodeExpand", function DocumentChecklistNewLibraryComponent_Template_p_tree_onNodeExpand_5_listener($event) { return ctx.nodeExpandCollapse($event, "expand"); })("onNodeCollapse", function DocumentChecklistNewLibraryComponent_Template_p_tree_onNodeCollapse_5_listener($event) { return ctx.nodeExpandCollapse($event, "collapse"); });
        i0.ɵɵtemplate(6, DocumentChecklistNewLibraryComponent_ng_template_6_Template, 22, 8, "ng-template", 5);
        i0.ɵɵtemplate(7, DocumentChecklistNewLibraryComponent_ng_template_7_Template, 3, 2, "ng-template", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(8, "p-confirmDialog", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, DocumentChecklistNewLibraryComponent_div_9_Template, 6, 1, "div", 8);
        i0.ɵɵtemplate(10, DocumentChecklistNewLibraryComponent_div_10_Template, 4, 0, "div", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(11, "p-confirmDialog", 9);
        i0.ɵɵelementStart(12, "p-dialog", 10);
        i0.ɵɵlistener("visibleChange", function DocumentChecklistNewLibraryComponent_Template_p_dialog_visibleChange_12_listener($event) { return ctx.displayDocumentPanel = $event; });
        i0.ɵɵtemplate(13, DocumentChecklistNewLibraryComponent_ng_template_13_Template, 5, 0, "ng-template", 11);
        i0.ɵɵelement(14, "hr", 12);
        i0.ɵɵelementStart(15, "div", 13);
        i0.ɵɵelementStart(16, "div", 14);
        i0.ɵɵelementStart(17, "h5", 15);
        i0.ɵɵtext(18, "Request document for");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div", 16);
        i0.ɵɵtemplate(20, DocumentChecklistNewLibraryComponent_div_20_Template, 2, 6, "div", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(21, "hr", 15);
        i0.ɵɵtemplate(22, DocumentChecklistNewLibraryComponent_p_22_Template, 2, 0, "p", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(23, DocumentChecklistNewLibraryComponent_div_23_Template, 2, 1, "div", 19);
        i0.ɵɵtemplate(24, DocumentChecklistNewLibraryComponent_p_divider_24_Template, 1, 0, "p-divider", 20);
        i0.ɵɵelementStart(25, "div", 21);
        i0.ɵɵelementStart(26, "div", 22);
        i0.ɵɵelementStart(27, "p-checkbox", 23);
        i0.ɵɵlistener("ngModelChange", function DocumentChecklistNewLibraryComponent_Template_p_checkbox_ngModelChange_27_listener($event) { return ctx.additionalDocuments = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "label", 24);
        i0.ɵɵtext(29, "Add Other Required Documents");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(30, "div", 21);
        i0.ɵɵelementStart(31, "div", 25);
        i0.ɵɵelementStart(32, "div", 26);
        i0.ɵɵelementStart(33, "label", 27);
        i0.ɵɵtext(34, "Title Sheet");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "p-dropdown", 28);
        i0.ɵɵlistener("ngModelChange", function DocumentChecklistNewLibraryComponent_Template_p_dropdown_ngModelChange_35_listener($event) { return ctx.selectedCategoryForNotification = $event; })("onChange", function DocumentChecklistNewLibraryComponent_Template_p_dropdown_onChange_35_listener() { return ctx.updateDocType(ctx.selectedCategoryForNotification, true); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(36, "div", 26);
        i0.ɵɵelementStart(37, "label", 27);
        i0.ɵɵtext(38, "Document Type");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(39, "p-dropdown", 29);
        i0.ɵɵlistener("ngModelChange", function DocumentChecklistNewLibraryComponent_Template_p_dropdown_ngModelChange_39_listener($event) { return ctx.selectedDocTypeForNotification = $event; })("onChange", function DocumentChecklistNewLibraryComponent_Template_p_dropdown_onChange_39_listener() { return ctx.setCustomEmpty(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(40, DocumentChecklistNewLibraryComponent_div_40_Template, 4, 1, "div", 30);
        i0.ɵɵelementStart(41, "div", 31);
        i0.ɵɵelementStart(42, "label", 32);
        i0.ɵɵtext(43, "1");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(44, "button", 33);
        i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_Template_button_click_44_listener() { return ctx.addNewCategory(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(45, "hr", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(46, DocumentChecklistNewLibraryComponent_div_46_Template, 3, 2, "div", 34);
        i0.ɵɵtemplate(47, DocumentChecklistNewLibraryComponent_div_47_Template, 5, 2, "div", 34);
        i0.ɵɵelementStart(48, "p-footer");
        i0.ɵɵelementStart(49, "button", 35);
        i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_Template_button_click_49_listener() { return ctx.displayDocumentPanel = false; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(50, "button", 36);
        i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_Template_button_click_50_listener() { return ctx.sendNotification(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(51, "p-dialog", 10);
        i0.ɵɵlistener("visibleChange", function DocumentChecklistNewLibraryComponent_Template_p_dialog_visibleChange_51_listener($event) { return ctx.displayAddDocumentPanel = $event; });
        i0.ɵɵtemplate(52, DocumentChecklistNewLibraryComponent_ng_template_52_Template, 5, 0, "ng-template", 11);
        i0.ɵɵelement(53, "hr", 12);
        i0.ɵɵelementStart(54, "div", 13);
        i0.ɵɵelementStart(55, "div", 14);
        i0.ɵɵelementStart(56, "label");
        i0.ɵɵtext(57, "Title Sheet: ");
        i0.ɵɵelementStart(58, "strong");
        i0.ɵɵtext(59);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(60, "div", 37);
        i0.ɵɵelementStart(61, "div", 14);
        i0.ɵɵelementStart(62, "form", 38);
        i0.ɵɵelementStart(63, "div", 39);
        i0.ɵɵelementStart(64, "label");
        i0.ɵɵtext(65, "Document Type");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(66, "p-dropdown", 40);
        i0.ɵɵlistener("onChange", function DocumentChecklistNewLibraryComponent_Template_p_dropdown_onChange_66_listener($event) { return ctx.onDocTypeSelect($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(67, DocumentChecklistNewLibraryComponent_div_67_Template, 2, 1, "div", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(68, DocumentChecklistNewLibraryComponent_div_68_Template, 5, 1, "div", 41);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(69, "p-footer");
        i0.ɵɵelementStart(70, "button", 42);
        i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_Template_button_click_70_listener() { return ctx.setDisplayAddDocumentPanel(false, null); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(71, "button", 43);
        i0.ɵɵlistener("click", function DocumentChecklistNewLibraryComponent_Template_button_click_71_listener() { return ctx.addDocumentType(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", ctx.disabledControls ? "form-disabled" : "");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.requiredDocumentsTree == null ? null : ctx.requiredDocumentsTree.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.requiredDocumentsTree == null ? null : ctx.requiredDocumentsTree.length);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("value", ctx.requiredDocumentsTree)("draggableNodes", ctx.isEdit)("droppableNodes", true)("validateDrop", true);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", (ctx.requiredDocumentsTree == null ? null : ctx.requiredDocumentsTree.length) && ctx.isEdit);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isEdit);
        i0.ɵɵadvance(2);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(46, _c4));
        i0.ɵɵproperty("styleClass", "doc-checklist-modal")("visible", ctx.displayDocumentPanel)("modal", true)("responsive", true)("minY", 70)("maximizable", false);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngForOf", ctx.requestDocNotifyToArray);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.supportingDocumentsForNotification == null ? null : ctx.supportingDocumentsForNotification.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.supportingDocumentsForNotification == null ? null : ctx.supportingDocumentsForNotification.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.supportingDocumentsForNotification == null ? null : ctx.supportingDocumentsForNotification.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("hidden", ctx.individualNotification);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.additionalDocuments);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("hidden", !ctx.additionalDocuments);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("options", ctx.categories)("ngModel", ctx.selectedCategoryForNotification);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("options", ctx.listDocumentTypes)("ngModel", ctx.selectedDocTypeForNotification);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedDocTypeForNotification === "Other");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.requestDocNotifyToArray.length > 1);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.requestDocNotifyToArray.length == 1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", !(ctx.supportingDocumentsForNotification == null ? null : ctx.supportingDocumentsForNotification.length));
        i0.ɵɵadvance(1);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(47, _c5));
        i0.ɵɵproperty("styleClass", "doc-checklist-modal")("visible", ctx.displayAddDocumentPanel)("modal", true)("responsive", true)("minY", 70)("maximizable", false);
        i0.ɵɵadvance(8);
        i0.ɵɵtextInterpolate(ctx.currentTitleSheet == null ? null : ctx.currentTitleSheet.data == null ? null : ctx.currentTitleSheet.data.titleSheetName);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("formGroup", ctx.addDocTypeForm);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("options", ctx.listDocumentTypes);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addDocTypeForm.controls["docType"].touched && ctx.addDocTypeForm.controls["docType"].invalid);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addDocTypeForm.controls["docType"].value === "Other");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", ctx.addDocTypeForm.invalid || ctx.addDocTypeFileSizeError);
    } }, directives: [i4.ɵangular_packages_forms_forms_ba, i4.NgControlStatusGroup, i4.NgForm, i5.NgClass, i5.NgIf, i6.Tree, i1$1.PrimeTemplate, i7.ConfirmDialog, i8.Dialog, i5.NgForOf, i9.Checkbox, i4.NgControlStatus, i4.NgModel, i10.Dropdown, i11.ButtonDirective, i1$1.Footer, i4.FormGroupDirective, i4.FormControlName, i4.RequiredValidator, i12.BulkDocumentsDownloadComponent, i13.MatIcon, i14.Inplace, i4.DefaultValueAccessor, i15.InputText, i16.Tooltip, i5.NgStyle, i17.RadioButton, i18.Divider], styles: [".p-datatable[_ngcontent-%COMP%]   .expandIcon[_ngcontent-%COMP%]{padding:10px 5px 5px!important}.p-datatable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:bottom;border-bottom:2px solid #dee2e6;font-style:normal;font-variant:normal;font-weight:700;font-size:13px}.p-datatable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .p-datatable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{padding:15px!important;color:#4a4a4a}.p-datatable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{border-top:none!important;font-size:14px}.p-datatable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{color:#4a4a4a}.title[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{color:#626262;margin-bottom:0}.title[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-weight:500}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 21px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 13px/22px Source Sans Pro}.action-block[_ngcontent-%COMP%]{text-align:end}.action-block[_ngcontent-%COMP%]   .add-title-sheet[_ngcontent-%COMP%]{vertical-align:super}.heading[_ngcontent-%COMP%]{color:#3d3d63}.p-button-outlined[_ngcontent-%COMP%]{padding:5px!important}.p-inputtext.ng-touched.ng-invalid[_ngcontent-%COMP%]{border-color:#f44336!important}.redColor[_ngcontent-%COMP%]{color:#f44336}.add-title-sheet[_ngcontent-%COMP%]   .p-button[_ngcontent-%COMP%]   .p-button-label[_ngcontent-%COMP%]{font-size:1rem;color:#10a0da}.add-title-sheet[_ngcontent-%COMP%]   .p-button[_ngcontent-%COMP%]   .p-button-icon[_ngcontent-%COMP%]{margin-left:0!important;padding:5px 7px!important;margin-right:2px}.add-doc-btn[_ngcontent-%COMP%]   .p-button[_ngcontent-%COMP%]{background:#fff!important;color:#10a0da!important;border:none!important;padding-top:0!important}.p-fileupload-choose[_ngcontent-%COMP%]   input[type=file][_ngcontent-%COMP%]{opacity:0;width:77px;position:absolute;cursor:pointer;display:block!important}.p-datatable-thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child{padding-left:2rem!important}.p-datatable-thead[_ngcontent-%COMP%]   th.dc-table-head[_ngcontent-%COMP%]{padding-left:0!important}.p-datatable-tbody[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{padding-left:2rem!important;position:relative}.p-datatable-tbody[_ngcontent-%COMP%]   .pi.pi-times-circle[_ngcontent-%COMP%]{position:absolute;left:1.5rem;font-size:1.3rem;cursor:pointer}.checkbox-outer[_ngcontent-%COMP%]   p-checkbox[_ngcontent-%COMP%]{align-items:start!important;padding-top:.2rem}.drag-drop-icon[_ngcontent-%COMP%]{cursor:pointer;position:relative;top:1px;font-size:1.1rem}.p-button.p-button-link[_ngcontent-%COMP%]:hover   .p-button-label[_ngcontent-%COMP%]{text-decoration:none!important}.pi-exclamation-triangle[_ngcontent-%COMP%]:before{color:#f44336!important}.form-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.5}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DocumentChecklistNewLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-document-checklist-new-library',
                templateUrl: 'document-checklist-new-library.component.html',
                styleUrls: ['document-checklist-new-library.component.scss']
            }]
    }], function () { return [{ type: i1$1.ConfirmationService }, { type: i2.ToastrService }, { type: undefined, decorators: [{
                type: Inject,
                args: [APIDocumentChecklist]
            }] }, { type: i3.SendNotificationService }]; }, { primaryData: [{
            type: Input
        }], disabledControls: [{
            type: Input
        }], documentChecklistForm: [{
            type: ViewChild,
            args: ['documentChecklistForm', { static: true }]
        }] }); })();

function RequestedDocumentListComponent_div_0_ng_container_7_th_1_p_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-checkbox", 16);
    i0.ɵɵlistener("onChange", function RequestedDocumentListComponent_div_0_ng_container_7_th_1_p_checkbox_1_Template_p_checkbox_onChange_0_listener($event) { i0.ɵɵrestoreView(_r14); const list_r1 = i0.ɵɵnextContext(3).$implicit; const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.selectAllDocs($event, list_r1); })("ngModelChange", function RequestedDocumentListComponent_div_0_ng_container_7_th_1_p_checkbox_1_Template_p_checkbox_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r14); const list_r1 = i0.ɵɵnextContext(3).$implicit; return (list_r1["isAllSelected"] = $event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ind_r8 = i0.ɵɵnextContext(2).index;
    const ctx_r17 = i0.ɵɵnextContext();
    const i_r2 = ctx_r17.index;
    const list_r1 = ctx_r17.$implicit;
    i0.ɵɵpropertyInterpolate2("name", "selectedAll", i_r2, "", ind_r8, "");
    i0.ɵɵpropertyInterpolate2("inputId", "documentType", i_r2, "", ind_r8, "");
    i0.ɵɵproperty("ngModel", list_r1["isAllSelected"]);
} }
function RequestedDocumentListComponent_div_0_ng_container_7_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 14);
    i0.ɵɵtemplate(1, RequestedDocumentListComponent_div_0_ng_container_7_th_1_p_checkbox_1_Template, 1, 5, "p-checkbox", 15);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext();
    const column_r7 = ctx_r19.$implicit;
    const ind_r8 = ctx_r19.index;
    i0.ɵɵpropertyInterpolate("width", column_r7["width"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ind_r8 === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", column_r7.header, " ");
} }
function RequestedDocumentListComponent_div_0_ng_container_7_td_2_p_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-checkbox", 22);
    i0.ɵɵlistener("onChange", function RequestedDocumentListComponent_div_0_ng_container_7_td_2_p_checkbox_1_Template_p_checkbox_onChange_0_listener($event) { i0.ɵɵrestoreView(_r27); const list_r1 = i0.ɵɵnextContext(3).$implicit; const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.selectDoc($event, list_r1); })("ngModelChange", function RequestedDocumentListComponent_div_0_ng_container_7_td_2_p_checkbox_1_Template_p_checkbox_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r27); const row_r20 = i0.ɵɵnextContext().$implicit; return (row_r20["isSelected"] = $event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r20 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate1("name", "selected", row_r20["titleSheetDetailId"], "");
    i0.ɵɵpropertyInterpolate1("value", "docTypes", row_r20["titleSheetDetailId"], "");
    i0.ɵɵpropertyInterpolate1("inputId", "documentType", row_r20["titleSheetDetailId"], "");
    i0.ɵɵproperty("ngModel", row_r20["isSelected"]);
} }
function RequestedDocumentListComponent_div_0_ng_container_7_td_2_p_checkbox_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-checkbox", 23);
} if (rf & 2) {
    i0.ɵɵproperty("disabled", true);
} }
function RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_3_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 30);
    i0.ɵɵlistener("click", function RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_3_mat_icon_1_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r37); const row_r20 = i0.ɵɵnextContext(2).$implicit; const ctx_r35 = i0.ɵɵnextContext(3); return ctx_r35.viewDocument(row_r20); });
    i0.ɵɵtext(1, "visibility");
    i0.ɵɵelementEnd();
} }
function RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_3_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 31);
    i0.ɵɵlistener("click", function RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_3_mat_icon_2_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r40); const row_r20 = i0.ɵɵnextContext(2).$implicit; const ctx_r38 = i0.ɵɵnextContext(3); return ctx_r38.deleteDoc(row_r20); });
    i0.ɵɵtext(1, "delete");
    i0.ɵɵelementEnd();
} }
function RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_3_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 32);
    i0.ɵɵlistener("click", function RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_3_mat_icon_3_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r42); i0.ɵɵnextContext(); const _r34 = i0.ɵɵreference(5); return _r34.click(); });
    i0.ɵɵtext(1, "publish");
    i0.ɵɵelementEnd();
} }
function RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_3_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 24);
    i0.ɵɵtemplate(1, RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_3_mat_icon_1_Template, 2, 0, "mat-icon", 25);
    i0.ɵɵtemplate(2, RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_3_mat_icon_2_Template, 2, 0, "mat-icon", 26);
    i0.ɵɵtemplate(3, RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_3_mat_icon_3_Template, 2, 0, "mat-icon", 27);
    i0.ɵɵelementStart(4, "input", 28, 29);
    i0.ɵɵlistener("change", function RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_3_Template_input_change_4_listener($event) { i0.ɵɵrestoreView(_r45); const row_r20 = i0.ɵɵnextContext().$implicit; const ctx_r43 = i0.ɵɵnextContext(3); return ctx_r43.uploadDoc($event.target.files, row_r20); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r20 = i0.ɵɵnextContext().$implicit;
    const ctx_r23 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", row_r20["present"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", row_r20["present"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !row_r20["present"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("accept", ctx_r23.acceptedTypes);
} }
function RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r20 = i0.ɵɵnextContext(2).$implicit;
    const column_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(row_r20[column_r7.columnDef]);
} }
function RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r20 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(row_r20["documents"][0]["fileName"]);
} }
function RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_4_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵelement(1, "i", 37);
    i0.ɵɵtext(2, " Document Missing ");
    i0.ɵɵelementEnd();
} }
const _c0$1 = function (a0, a1) { return { "doc-name": a0, "file-name": a1 }; };
function RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 33);
    i0.ɵɵtemplate(1, RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_4_span_1_Template, 2, 1, "span", 34);
    i0.ɵɵtemplate(2, RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_4_span_2_Template, 2, 1, "span", 34);
    i0.ɵɵtemplate(3, RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_4_span_3_Template, 3, 0, "span", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r20 = i0.ɵɵnextContext().$implicit;
    const column_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c0$1, column_r7.columnDef == "docName", column_r7.columnDef == "fileName"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r7.columnDef == "docName");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r7.columnDef == "fileName" && row_r20["documents"].length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r7.columnDef == "fileName" && !row_r20["present"]);
} }
function RequestedDocumentListComponent_div_0_ng_container_7_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 17);
    i0.ɵɵtemplate(1, RequestedDocumentListComponent_div_0_ng_container_7_td_2_p_checkbox_1_Template, 1, 4, "p-checkbox", 18);
    i0.ɵɵtemplate(2, RequestedDocumentListComponent_div_0_ng_container_7_td_2_p_checkbox_2_Template, 1, 1, "p-checkbox", 19);
    i0.ɵɵtemplate(3, RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_3_Template, 6, 4, "span", 20);
    i0.ɵɵtemplate(4, RequestedDocumentListComponent_div_0_ng_container_7_td_2_span_4_Template, 4, 7, "span", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r20 = ctx.$implicit;
    const ctx_r55 = i0.ɵɵnextContext();
    const ind_r8 = ctx_r55.index;
    const column_r7 = ctx_r55.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ind_r8 === 0 && row_r20["present"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ind_r8 === 0 && !row_r20["present"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r7.columnType == "icon");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r7.columnType == "text");
} }
function RequestedDocumentListComponent_div_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 11);
    i0.ɵɵtemplate(1, RequestedDocumentListComponent_div_0_ng_container_7_th_1_Template, 3, 3, "th", 12);
    i0.ɵɵtemplate(2, RequestedDocumentListComponent_div_0_ng_container_7_td_2_Template, 5, 4, "td", 13);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r7 = ctx.$implicit;
    i0.ɵɵproperty("matColumnDef", column_r7.columnDef);
} }
function RequestedDocumentListComponent_div_0_tr_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 38);
} }
function RequestedDocumentListComponent_div_0_tr_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 39);
} }
function RequestedDocumentListComponent_div_0_tr_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 40);
    i0.ɵɵelementStart(1, "td", 41);
    i0.ɵɵtext(2, "No data");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RequestedDocumentListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "h6", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵelementStart(5, "div", 5);
    i0.ɵɵelementStart(6, "table", 6);
    i0.ɵɵtemplate(7, RequestedDocumentListComponent_div_0_ng_container_7_Template, 3, 1, "ng-container", 7);
    i0.ɵɵtemplate(8, RequestedDocumentListComponent_div_0_tr_8_Template, 1, 0, "tr", 8);
    i0.ɵɵtemplate(9, RequestedDocumentListComponent_div_0_tr_9_Template, 1, 0, "tr", 9);
    i0.ɵɵtemplate(10, RequestedDocumentListComponent_div_0_tr_10_Template, 3, 0, "tr", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const list_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(list_r1.titleSheetName);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("dataSource", list_r1.documentTypes);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.columns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r0.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r0.displayedColumns);
} }
class RequestedDocumentListComponent {
    constructor(confirmationService) {
        this.confirmationService = confirmationService;
        this.onFileSelected = new EventEmitter();
        this.onFileDelete = new EventEmitter();
        this.onDcoumentSelect = new EventEmitter();
        this.displayedColumns = [];
        this.columns = [
            {
                columnDef: 'docName', header: 'Document Type', columnType: 'text', customClass: '', width: '40%'
            }, {
                columnDef: 'fileName', header: 'Document Name', columnType: 'text', customClass: '', width: '40%'
            }, {
                columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '', width: '20%'
            }
        ];
        this.acceptedTypes = acceptedFileTypes;
    }
    ngOnInit() {
    }
    ngAfterContentInit() {
        this.displayedColumns = this.columns.map(c => c.columnDef);
    }
    ngOnChanges() {
        this.requestedDocsList = this.docList.map((item) => {
            item.documentTypes = new MatTableDataSource(item.documentTypes);
            return item;
        });
    }
    uploadDoc(files, row) {
        const file = files.item(0);
        this.onFileSelected.emit({ file: file, item: row });
    }
    viewDocument(item) {
        const docPath = item['documents'][0]['fileLocation'].substring(23);
        window.open(`${environment.docs}${docPath}`, "_blank");
    }
    selectAllDocs(event, list) {
        list.documentTypes['filteredData'].forEach((item) => {
            if (item['documents'].length)
                item['isSelected'] = list['isAllSelected'];
        });
        //update selected files
        this.buildSelectedFiles();
    }
    selectDoc(event, list) {
        const checkedItems = list.documentTypes['filteredData'].filter((doc) => doc.isSelected && doc['documents'].length).length;
        const totalItems = list.documentTypes['filteredData'].filter((doc) => doc['documents'].length).length;
        list.isAllSelected = (checkedItems === totalItems);
        //update selected files
        this.buildSelectedFiles();
    }
    buildSelectedFiles() {
        let selectedFiles = [];
        this.requestedDocsList.forEach(item => {
            item.documentTypes['filteredData'].forEach((doc) => {
                if (doc['isSelected'] && doc['documents'].length)
                    selectedFiles.push({ fileLocation: doc['documents'][0]['fileLocation'], fileName: doc['documents'][0]['fileName'] });
            });
        });
        this.onDcoumentSelect.emit(selectedFiles);
    }
    deleteDoc(row) {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete?',
            key: 'deletedoc',
            accept: () => {
                this.onFileDelete.emit(row);
            },
            reject: () => {
            }
        });
    }
}
RequestedDocumentListComponent.ɵfac = function RequestedDocumentListComponent_Factory(t) { return new (t || RequestedDocumentListComponent)(i0.ɵɵdirectiveInject(i1$1.ConfirmationService)); };
RequestedDocumentListComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RequestedDocumentListComponent, selectors: [["lib-requested-document-list"]], inputs: { docList: "docList", extras: "extras" }, outputs: { onFileSelected: "onFileSelected", onFileDelete: "onFileDelete", onDcoumentSelect: "onDcoumentSelect" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "mb-3 list-outer", 4, "ngFor", "ngForOf"], [1, "mb-3", "list-outer"], [1, "title-sheet-head"], [1, "pb-2", "title-sheet-name"], [1, "list-inner"], [1, "table-responsive"], ["mat-table", "", 1, "im-card-no-border-table", "table", "im-card-table-noborder-spacing", "table-striped-simple", 3, "dataSource"], [3, "matColumnDef", 4, "ngFor", "ngForOf"], ["mat-header-row", "", 4, "matHeaderRowDef"], ["mat-row", "", 4, "matRowDef", "matRowDefColumns"], ["class", "mat-row", 4, "matNoDataRow"], [3, "matColumnDef"], ["mat-header-cell", "", 3, "width", 4, "matHeaderCellDef"], ["mat-cell", "", 4, "matCellDef"], ["mat-header-cell", "", 3, "width"], ["value", "true", "binary", "true", "class", "pr-2", 3, "name", "inputId", "ngModel", "onChange", "ngModelChange", 4, "ngIf"], ["value", "true", "binary", "true", 1, "pr-2", 3, "name", "inputId", "ngModel", "onChange", "ngModelChange"], ["mat-cell", ""], ["binary", "true", "class", "pr-2", 3, "name", "value", "inputId", "ngModel", "onChange", "ngModelChange", 4, "ngIf"], ["class", "pr-2", 3, "disabled", 4, "ngIf"], ["class", "column.customClass", 4, "ngIf"], [3, "ngClass", 4, "ngIf"], ["binary", "true", 1, "pr-2", 3, "name", "value", "inputId", "ngModel", "onChange", "ngModelChange"], [1, "pr-2", 3, "disabled"], [1, "column.customClass"], ["pTooltip", "View", "class", "mr-1 icn", "matTooltip", "View", 3, "click", 4, "ngIf"], ["class", "mr-1 icn", "pTooltip", "Delete", "class", "material-icons", 3, "click", 4, "ngIf"], ["pTooltip", "Upload", "class", "mr-1 icn", 3, "click", 4, "ngIf"], ["type", "file", 2, "display", "none", 3, "accept", "change"], ["uploadFile", ""], ["pTooltip", "View", "matTooltip", "View", 1, "mr-1", "icn", 3, "click"], ["pTooltip", "Delete", 1, "material-icons", 3, "click"], ["pTooltip", "Upload", 1, "mr-1", "icn", 3, "click"], [3, "ngClass"], [4, "ngIf"], ["class", "redColor d-flex align-items-center", 4, "ngIf"], [1, "redColor", "d-flex", "align-items-center"], [1, "pi", "pi-exclamation-triangle", "pr-2"], ["mat-header-row", ""], ["mat-row", ""], [1, "mat-row"], ["colspan", "3", 1, "mat-cell", 2, "text-align", "center"]], template: function RequestedDocumentListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, RequestedDocumentListComponent_div_0_Template, 11, 5, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.requestedDocsList);
    } }, directives: [i5.NgForOf, i3$1.MatTable, i3$1.MatHeaderRowDef, i3$1.MatRowDef, i3$1.MatNoDataRow, i3$1.MatColumnDef, i3$1.MatHeaderCellDef, i3$1.MatCellDef, i3$1.MatHeaderCell, i5.NgIf, i9.Checkbox, i4.NgControlStatus, i4.NgModel, i3$1.MatCell, i13.MatIcon, i16.Tooltip, i5.NgClass, i3$1.MatHeaderRow, i3$1.MatRow], styles: [".redColor[_ngcontent-%COMP%]{color:#f44336}.mat-column-documentName[_ngcontent-%COMP%], .mat-column-documentType[_ngcontent-%COMP%]{width:40%}.mat-column-action[_ngcontent-%COMP%]{width:20%}.page-subheading[_ngcontent-%COMP%]{font:normal normal 600 16px/14px Source Sans Pro}.title-sheet-name[_ngcontent-%COMP%]{font:normal normal 600 14px/10px Source Sans Pro}.list-outer[_ngcontent-%COMP%]{padding:10px 20px;border:1px solid #e0e0e0}.mat-table[_ngcontent-%COMP%]   tr.mat-row[_ngcontent-%COMP%]   td.mat-cell[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{margin-bottom:0!important}.mat-table[_ngcontent-%COMP%]   tr.mat-row[_ngcontent-%COMP%]   td.mat-cell[_ngcontent-%COMP%]   span.doc-name[_ngcontent-%COMP%]{width:90%!important}.mat-table[_ngcontent-%COMP%]   tr.mat-row[_ngcontent-%COMP%]   td.mat-cell[_ngcontent-%COMP%]   span.p-checkbox-icon[_ngcontent-%COMP%]{margin-bottom:0!important}.pi-exclamation-triangle[_ngcontent-%COMP%]:before{color:#f44336!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RequestedDocumentListComponent, [{
        type: Component,
        args: [{
                selector: 'lib-requested-document-list',
                templateUrl: './requested-document-list.component.html',
                styleUrls: ['./requested-document-list.component.scss']
            }]
    }], function () { return [{ type: i1$1.ConfirmationService }]; }, { docList: [{
            type: Input
        }], extras: [{
            type: Input
        }], onFileSelected: [{
            type: Output
        }], onFileDelete: [{
            type: Output
        }], onDcoumentSelect: [{
            type: Output
        }] }); })();

function RequestedDocumentsComponent_i_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 17);
} }
const _c0 = function () { return ["K1", "K3"]; };
function RequestedDocumentsComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "label", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r1.SubTaskTypeList.includes("I130") || i0.ɵɵpureFunction0(2, _c0).includes(ctx_r1.superTaskDetails.visaType == null ? null : ctx_r1.superTaskDetails.visaType.code) ? "Sponsor: " : "Beneficiary: ", "", ctx_r1.SubTaskTypeList.includes("I130") ? (ctx_r1.superTaskDetails == null ? null : ctx_r1.superTaskDetails.sponsorFirstName) + " " + (ctx_r1.superTaskDetails == null ? null : ctx_r1.superTaskDetails.sponsorLastName) : (ctx_r1.superTaskDetails == null ? null : ctx_r1.superTaskDetails.beneficiaryFirstName) + " " + (ctx_r1.superTaskDetails == null ? null : ctx_r1.superTaskDetails.beneficiaryLastName), " ");
} }
function RequestedDocumentsComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "label", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Company : ", ctx_r2.superTaskDetails == null ? null : ctx_r2.superTaskDetails.companyName, "");
} }
const _c1 = function (a0) { return { "border-right border-dark": a0 }; };
function RequestedDocumentsComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const summaryDetail_r7 = ctx.$implicit;
    const i_r8 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("p", i_r8 < ctx_r3.summaryDetailsList.length - 1 ? "x" : "l", "-2 mb-0");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1, i_r8 < ctx_r3.summaryDetailsList.length - 1));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", summaryDetail_r7 == null ? null : summaryDetail_r7.name, " : ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(summaryDetail_r7 == null ? null : summaryDetail_r7.value);
} }
const _c2 = function () { return []; };
function RequestedDocumentsComponent_lib_requested_document_list_16_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-requested-document-list", 22);
    i0.ɵɵlistener("onFileSelected", function RequestedDocumentsComponent_lib_requested_document_list_16_Template_lib_requested_document_list_onFileSelected_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.onDocUpload($event); })("onFileDelete", function RequestedDocumentsComponent_lib_requested_document_list_16_Template_lib_requested_document_list_onFileDelete_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.onDocDelete($event); })("onDcoumentSelect", function RequestedDocumentsComponent_lib_requested_document_list_16_Template_lib_requested_document_list_onDcoumentSelect_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.onDocSelect($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("docList", ctx_r4.requestedDocsList)("extras", i0.ɵɵpureFunction0(2, _c2));
} }
function RequestedDocumentsComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span", 24);
    i0.ɵɵtext(2, "No Data Available");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RequestedDocumentsComponent_button_18_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function RequestedDocumentsComponent_button_18_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.markSubmit(); });
    i0.ɵɵelementStart(1, "span", 26);
    i0.ɵɵtext(2, "Mark Submit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r6.isAnyDocumentUploaded);
} }
class RequestedDocumentsComponent {
    constructor(route, toastr, apiService) {
        this.route = route;
        this.toastr = toastr;
        this.apiService = apiService;
        this.requestedDocsList = [];
        this.uploadedFiles = [];
        this.documentsNotUploaded = 0;
        this.isAnyDocumentUploaded = false;
        this.destroy$ = new Subject();
        this.maxfileSizeInMB = 10;
        this.subTaskList = [];
        this.selectedFiles = [];
        this.bulkDownloadCheckboxes = [];
        this.groupBy = function (arr, key) {
            return arr.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        };
    }
    ngOnInit() {
        this.userType = sessionStorage.getItem("userTypeRole");
        this.route.params.subscribe((params) => {
            this.taskId = +params["taskId"];
            this.getTask();
        });
    }
    ngAfterContentInit() {
        setTimeout(() => {
            this.menuItems = document.getElementById('navbarSupportedContent').getElementsByClassName('im-nav-item');
            this.menuItems[1].classList.add('active');
        }, 0);
    }
    getTask() {
        this.apiService.getSuperTask(this.taskId)
            .pipe(takeUntil(this.destroy$), take(1)).subscribe((data) => {
            var _a, _b;
            //console.log('data:',data);
            let { subTaskList, superTask } = data;
            this.superTaskDetails = superTask;
            this.subTaskList = subTaskList.filter((x) => x.taskTypeCode != 'RFE');
            this.SubTaskTypeList = this.subTaskList.map((x) => { return x.taskTypeCode; });
            let petition = subTaskList.filter((x) => ['PETITION', 'I140', 'I130', 'PWD', 'RECEFF', 'PERM'].includes(x.taskTypeCode));
            //console.log('petition:',petition);
            this.caseId = superTask['caseId'] ? superTask['caseId'] : null;
            this.subTaskId = (_a = petition[0]) === null || _a === void 0 ? void 0 : _a.id;
            this.visaType = superTask['visaType'] ? superTask['visaType']['code'] : null;
            this.caseType = (_b = petition[0]) === null || _b === void 0 ? void 0 : _b.taskTypeCode;
            this.pouplateTaskHeaderSummary();
            const caseIds = this.subTaskList.filter((x) => !x.caseId && !x.petitionId);
            if (caseIds.length) {
                const requestSubArray = [];
                caseIds.forEach((pet) => {
                    requestSubArray.push(this.apiService.getTask(pet.id));
                });
                forkJoin(requestSubArray).pipe(takeUntil(this.destroy$)).subscribe(results => {
                    results.forEach((response, index) => {
                        let caseId = response['petitionId'] ? response['petitionId'] : response['caseId'];
                        this.subTaskList[index]['caseId'] = caseId;
                    });
                    this.loadDocuments();
                });
            }
            else {
                this.loadDocuments();
            }
        });
    }
    pouplateTaskHeaderSummary() {
        this.summaryDetailsList = [];
        //console.log('this.SubTaskTypeList:',this.SubTaskTypeList);
        if (this.SubTaskTypeList.includes('PETITION') && this.superTaskDetails.visaType) {
            const visatype = {
                name: 'Visa Type',
                value: this.superTaskDetails.visaType ? this.superTaskDetails.visaType.name : ''
            };
            const petitiontype = {
                name: 'Petition Type',
                value: this.superTaskDetails.petitionType ? this.superTaskDetails.petitionType.name : ''
            };
            this.summaryDetailsList.push(visatype, petitiontype);
        }
        else if (this.SubTaskTypeList.includes('PERM') || this.SubTaskTypeList.includes('RECEFF') || this.SubTaskTypeList.includes('PWD') || this.SubTaskTypeList.includes('I140')) {
            const catergory = {
                name: 'Category',
                value: this.superTaskDetails.immigrationCategory ? this.superTaskDetails.immigrationCategory.name : ''
            };
            const classification = {
                name: 'Classification',
                value: this.superTaskDetails.immigrationClassification ? this.superTaskDetails.immigrationClassification.name : ''
            };
            this.visaType = this.superTaskDetails.immigrationClassification ? this.superTaskDetails.immigrationClassification.name : '';
            this.summaryDetailsList.push(catergory, classification);
        }
        else if (this.SubTaskTypeList.includes('I130') || !this.superTaskDetails['visaType']) {
            const category = {
                name: 'Category',
                value: this.superTaskDetails.immigrationCategory &&
                    this.superTaskDetails.immigrationCategory.name ?
                    this.superTaskDetails.immigrationCategory.name : ''
            };
            const classification = {
                name: 'Classification',
                value: this.superTaskDetails.immigrationClassification ? this.superTaskDetails.immigrationClassification.name : ''
            };
            this.visaType = this.superTaskDetails.immigrationClassification ? this.superTaskDetails.immigrationClassification.group : '';
            this.summaryDetailsList.push(category, classification);
        }
        //console.log('summaryDetailsList:',this.summaryDetailsList);
    }
    loadDocuments() {
        this.isAnyDocumentUploaded = false;
        let isFrom = this.userType === 'Petitioner' ? 'employee' : 'beneficiary';
        let benPetId = this.userType === 'Petitioner' ? parseInt(sessionStorage.getItem('employeeId')) : parseInt(sessionStorage.getItem('beneficiaryId'));
        // console.log('this.subTaskList:',this.subTaskList);
        const requestArray = [];
        this.subTaskList.forEach((pet) => {
            let caseId = pet['petitionId'] ? pet['petitionId'] : pet['caseId'];
            requestArray.push(this.apiService.getRequestedDocuments(this.visaType, pet['taskTypeCode'], caseId, benPetId, isFrom));
        });
        forkJoin(requestArray).pipe(takeUntil(this.destroy$)).subscribe(results => {
            // console.log(results);
            let tempArr = [];
            results.forEach((response, index) => {
                if (response) {
                    let titleSheetDocDtoList = this.groupBy(response['titleSheetDocDtoList'], 'categoryName');
                    Object.keys(titleSheetDocDtoList).forEach((key) => {
                        let titleSheetObj = { titleSheetName: key, titleSheetId: "", documentTypes: [], petitionId: response['petitionId'] ? response['petitionId'] : null, caseId: this.subTaskList[index] ? (this.subTaskList[index]['caseId'] ? this.subTaskList[index]['caseId'] : this.subTaskList[index]['petitionId']) : null, 'subTaskId': this.subTaskList[index]['id'] };
                        titleSheetDocDtoList[key].forEach((item) => {
                            if (item['pbDocList'].length > 0) {
                                titleSheetObj.titleSheetId = item['pbDocList'][0]['titleSheetId'];
                                item['pbDocList'][0]['documentTypes'][0]['titleSheetId'] = item['pbDocList'][0]['titleSheetId'];
                                item['pbDocList'][0]['documentTypes'][0]['titleSheetName'] = item['pbDocList'][0]['titleSheetName'];
                                item['pbDocList'][0]['documentTypes'][0]['petitionId'] = response['petitionId'] ? response['petitionId'] : null;
                                item['pbDocList'][0]['documentTypes'][0]['caseId'] = this.subTaskList[index] ? (this.subTaskList[index]['caseId'] ? this.subTaskList[index]['caseId'] : this.subTaskList[index]['petitionId']) : null;
                                item['pbDocList'][0]['documentTypes'][0]['caseType'] = this.subTaskList[index] ? this.subTaskList[index]['taskTypeCode'] : null;
                                item['pbDocList'][0]['documentTypes'][0]['subTaskId'] = this.subTaskList[index] ? this.subTaskList[index]['id'] : null;
                                titleSheetObj.documentTypes.push(item['pbDocList'][0]['documentTypes'][0]);
                            }
                        });
                        if (titleSheetObj.documentTypes.length) {
                            tempArr.push(titleSheetObj);
                        }
                    });
                }
            });
            this.checkForMarkComplete(tempArr);
            this.requestedDocsList = tempArr;
            //console.log('this.requestedDocsList::', this.requestedDocsList,'this.documentsNotUploaded:',this.documentsNotUploaded,'isAnyDocumentUploaded:',this.isAnyDocumentUploaded);
        });
    }
    onDocUpload(data) {
        let { file, item } = data;
        if (file.size / 1024 / 1024 > this.maxfileSizeInMB) {
            this.toastr.error(`File size should be less than or equal to ${this.maxfileSizeInMB}MB`);
            return;
        }
        file.fileName = file.name;
        const payload = new FormData();
        payload.append('file', file, file.name);
        //console.log('data:',data);
        if ((item === null || item === void 0 ? void 0 : item.fileCategoryCode) == 'OTHER') {
            payload.append('otherName', item === null || item === void 0 ? void 0 : item.docName);
            payload.append('fileCategoryId', item === null || item === void 0 ? void 0 : item.fileCategory);
            payload.append('titleSheetName', item === null || item === void 0 ? void 0 : item.titleSheetName);
            payload.append('titleSheetDetailId', item === null || item === void 0 ? void 0 : item.titleSheetDetailId);
            payload.append('titleSheetId', item === null || item === void 0 ? void 0 : item.titleSheetId);
        }
        if (item['familyId']) {
            payload.append('familyId', item['familyId']);
        }
        let entityId = this.getEntityId(item);
        this.apiService.saveRequestedDocument(this.visaType, item === null || item === void 0 ? void 0 : item.caseType, item === null || item === void 0 ? void 0 : item.caseId, item === null || item === void 0 ? void 0 : item.fileGroupCategoryCode, item === null || item === void 0 ? void 0 : item.fileCategoryCode, entityId, this.superTaskDetails['superTaskId'], item === null || item === void 0 ? void 0 : item.subTaskId, payload).subscribe((response) => {
            this.loadDocuments();
            this.toastr.success(response.message);
        });
    }
    onDocDelete(data) {
        var _a;
        this.apiService.deleteDocument(this.visaType, data === null || data === void 0 ? void 0 : data.caseType, data === null || data === void 0 ? void 0 : data.caseId, (_a = data['documents'][0]) === null || _a === void 0 ? void 0 : _a.id, this.superTaskDetails['superTaskId'], data === null || data === void 0 ? void 0 : data.subTaskId)
            .pipe(takeUntil(this.destroy$))
            .subscribe((response) => {
            this.loadDocuments();
            this.toastr.success(response.message);
        });
    }
    checkForMarkComplete(allDocs) {
        if (!allDocs.length)
            return;
        //let docsCount = 0;
        allDocs.forEach((el) => {
            //docsCount += el?.documentTypes.filter((x)=> !x.present).length;
            const uploadedDocs = el === null || el === void 0 ? void 0 : el.documentTypes.filter((x) => x.present).length;
            if (uploadedDocs > 0) {
                this.isAnyDocumentUploaded = true;
            }
        });
        //this.documentsNotUploaded = docsCount;
    }
    markSubmit() {
        const requestArray = [];
        this.subTaskList.forEach((pet) => {
            if (!['RECEFF', 'PWD', 'RFE', 'PERM'].includes(pet.taskTypeCode)) {
                let taskId = pet.id;
                requestArray.push(this.apiService.notifiReviewer(taskId));
            }
        });
        const responseArr = [];
        forkJoin(requestArray).pipe(takeUntil(this.destroy$)).subscribe(results => {
            results.forEach((response) => {
                responseArr.push(response['message']);
            });
            if (responseArr.length) {
                this.loadDocuments();
                this.toastr.success(responseArr[0]);
            }
        });
    }
    onDocSelect(selectedDocs) {
        this.selectedFiles = selectedDocs;
    }
    getEntityId(item) {
        var _a;
        if (item && item['entityId']) {
            return item['entityId'];
        }
        if (['COMPGENDOC', 'COMPOTHDOC'].includes(item['fileGroupCategoryCode'])) {
            return (_a = this.superTaskDetails) === null || _a === void 0 ? void 0 : _a.companyId;
        }
        return null;
    }
    ngOnDestroy() {
        this.menuItems[1].classList.remove('active');
        this.destroy$.complete();
    }
}
RequestedDocumentsComponent.ɵfac = function RequestedDocumentsComponent_Factory(t) { return new (t || RequestedDocumentsComponent)(i0.ɵɵdirectiveInject(i1$2.ActivatedRoute), i0.ɵɵdirectiveInject(i2.ToastrService), i0.ɵɵdirectiveInject(i3$2.APIDocumentChecklist)); };
RequestedDocumentsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RequestedDocumentsComponent, selectors: [["lib-requested-documents"]], decls: 20, vars: 11, consts: [[1, "container-fluid"], [1, "row", "pl--1rem8", "d-flex", "align-items-center"], [1, "col-md-12"], [1, "page-header"], ["matBadgePosition", "after", "matBadgeColor", "warn", 1, "pl-1", 3, "matBadgeHidden", "matBadge", "matBadgeOverlap"], ["class", "pl-3 ml-4 pi pi-exclamation-triangle pr-2 redColor", 4, "ngIf"], [1, "row", "pl--1rem8", "d-flex", "pt-2", "task-header-summary"], [1, "col", "d-flex", "p-justify-end", "align-items-end"], ["class", "border-right pr-2 border-dark", 4, "ngIf"], ["ngFor", "", 3, "ngForOf"], ["fileName", "Petition-Documents.zip", 3, "selectedFiles"], [1, "row", "mr-2rem"], [1, "col-md-12", "m-3", "p-4", "bg-white"], [3, "docList", "extras", "onFileSelected", "onFileDelete", "onDcoumentSelect", 4, "ngIf"], ["class", "mb-3 list-outer", "style", "text-align: center;", 4, "ngIf"], ["type", "button", "title", "Mark Submit", "class", "btn btn-primary btn-lg mark-complete-btn", 3, "disabled", "click", 4, "ngIf"], ["header", "Delete", "key", "deletedoc"], [1, "pl-3", "ml-4", "pi", "pi-exclamation-triangle", "pr-2", "redColor"], [1, "border-right", "pr-2", "border-dark"], [1, "mb-0"], [1, "d-inline-block", "pl-1"], [3, "ngClass"], [3, "docList", "extras", "onFileSelected", "onFileDelete", "onDcoumentSelect"], [1, "mb-3", "list-outer", 2, "text-align", "center"], [1, "no-data-text", 2, "font-size", "15px"], ["type", "button", "title", "Mark Submit", 1, "btn", "btn-primary", "btn-lg", "mark-complete-btn", 3, "disabled", "click"], [1, "paddingLeft10", "paddingRight10"]], template: function RequestedDocumentsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "h2");
        i0.ɵɵtext(5, "Requested Document List ");
        i0.ɵɵelement(6, "span", 4);
        i0.ɵɵtemplate(7, RequestedDocumentsComponent_i_7_Template, 1, 0, "i", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵelementStart(9, "div", 7);
        i0.ɵɵtemplate(10, RequestedDocumentsComponent_div_10_Template, 3, 3, "div", 8);
        i0.ɵɵtemplate(11, RequestedDocumentsComponent_div_11_Template, 4, 1, "div", 8);
        i0.ɵɵtemplate(12, RequestedDocumentsComponent_ng_template_12_Template, 4, 8, "ng-template", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(13, "lib-bulk-documents-download", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 11);
        i0.ɵɵelementStart(15, "div", 12);
        i0.ɵɵtemplate(16, RequestedDocumentsComponent_lib_requested_document_list_16_Template, 1, 3, "lib-requested-document-list", 13);
        i0.ɵɵtemplate(17, RequestedDocumentsComponent_div_17_Template, 3, 0, "div", 14);
        i0.ɵɵtemplate(18, RequestedDocumentsComponent_button_18_Template, 3, 1, "button", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(19, "p-confirmDialog", 16);
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("matBadgeHidden", ctx.documentsNotUploaded === 0)("matBadge", ctx.documentsNotUploaded)("matBadgeOverlap", false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.documentsNotUploaded > 0);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.userType === "Petitioner");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.SubTaskTypeList.includes("I130") && ctx.userType === "Beneficiary");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.summaryDetailsList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("selectedFiles", ctx.selectedFiles);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.requestedDocsList.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.requestedDocsList.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.requestedDocsList.length);
    } }, directives: [i4$1.MatBadge, i5.NgIf, i5.NgForOf, i12.BulkDocumentsDownloadComponent, i7.ConfirmDialog, i5.NgClass, RequestedDocumentListComponent], styles: [".redColor[_ngcontent-%COMP%]{color:#f44336}.pi-exclamation-triangle[_ngcontent-%COMP%]{font-size:1.5rem}.mat-badge-medium.mat-badge-above[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{top:0!important}.mark-complete-btn[_ngcontent-%COMP%]{float:right}.btn-primary[_ngcontent-%COMP%]:disabled{box-shadow:none!important}.btn-primary[_ngcontent-%COMP%]:disabled:hover   span[_ngcontent-%COMP%]{border:none!important}.mr-2rem[_ngcontent-%COMP%]{margin-right:2rem!important}lib-bulk-documents-download[_ngcontent-%COMP%]{margin-right:17px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RequestedDocumentsComponent, [{
        type: Component,
        args: [{
                selector: 'lib-requested-documents',
                templateUrl: './requested-documents.component.html',
                styleUrls: ['./requested-documents.component.scss']
            }]
    }], function () { return [{ type: i1$2.ActivatedRoute }, { type: i2.ToastrService }, { type: i3$2.APIDocumentChecklist }]; }, null); })();

class DocumentChecklistNewLibraryModule {
    static forRoot(environment) {
        return {
            ngModule: DocumentChecklistNewLibraryModule,
            providers: [
                {
                    provide: 'env',
                    useValue: environment
                }
            ]
        };
    }
}
DocumentChecklistNewLibraryModule.ɵfac = function DocumentChecklistNewLibraryModule_Factory(t) { return new (t || DocumentChecklistNewLibraryModule)(); };
DocumentChecklistNewLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: DocumentChecklistNewLibraryModule });
DocumentChecklistNewLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseDocumentChecklistLibraryService], imports: [[
            PrimengLibraryModule,
            MatTableModule,
            MatBadgeModule,
            FormsModule,
            ReactiveFormsModule,
            BulkDocumentsDownloadModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DocumentChecklistNewLibraryModule, { declarations: [DocumentChecklistNewLibraryComponent, RequestedDocumentsComponent, RequestedDocumentListComponent], imports: [PrimengLibraryModule,
        MatTableModule,
        MatBadgeModule,
        FormsModule,
        ReactiveFormsModule,
        BulkDocumentsDownloadModule], exports: [DocumentChecklistNewLibraryComponent, RequestedDocumentsComponent, RequestedDocumentListComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DocumentChecklistNewLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [DocumentChecklistNewLibraryComponent, RequestedDocumentsComponent, RequestedDocumentListComponent],
                imports: [
                    PrimengLibraryModule,
                    MatTableModule,
                    MatBadgeModule,
                    FormsModule,
                    ReactiveFormsModule,
                    BulkDocumentsDownloadModule
                ],
                providers: [BaseDocumentChecklistLibraryService],
                exports: [DocumentChecklistNewLibraryComponent, RequestedDocumentsComponent, RequestedDocumentListComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of document-checklist-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DocumentChecklistNewLibraryComponent, DocumentChecklistNewLibraryModule, DocumentChecklistNewLibraryService, RequestedDocumentListComponent, RequestedDocumentsComponent };
//# sourceMappingURL=document-checklist-new-library.js.map
